/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSON: { input: string | string[]; output: string | string[]; }
};

export type Access = {
  __typename?: 'Access';
  /** @deprecated Use userId instead. learnWorldsId is a legacy field that will be removed. */
  learnWorldsId?: Maybe<Scalars['String']['output']>;
  redirectURL?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AddUserNewPlanInput = {
  email: Scalars['String']['input'];
  isAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
};

/** Backend-controlled app-update verdict for the caller's platform + version. */
export type AppUpdate = {
  __typename?: 'AppUpdate';
  badge?: Maybe<Scalars['String']['output']>;
  /** 'What's new' bullets (0..10), in order. */
  notes: Array<Scalars['String']['output']>;
  reassurance?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The version being gated on (soft floor for SOFT, min-supported for HARD). */
  targetVersion?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updateType: AppUpdateType;
};

export enum AppUpdateType {
  Hard = 'HARD',
  None = 'NONE',
  Soft = 'SOFT'
}

/**
 * An image, addressed twice.
 *
 * `name` is a stable KEY, not a filename. Each platform maps it to whatever it
 * actually ships, because no single string can name the same icon on both: iOS
 * wants `onboardingLmpFact1`, Android's own three are `ic_onboarding_lmp_fact_1`
 * and `img_onboarding_lmp_fact_2`, and Android resource names cannot carry capitals
 * at all. A key the build has no mapping for simply falls through to `url`, which is
 * exactly what makes new art release-free.
 *
 * Prefer `name` when the build knows it: no network, no blank frame on the screen
 * right after purchase. `url` is never absent, so there is always something to draw,
 * and it must be PNG or WebP — SDWebImage draws no SVG without a plugin, so an SVG
 * fallback is not a fallback.
 *
 * Changing the art means a new key. Reusing the old one leaves every shipped build
 * drawing what it already has.
 */
export type AssetRef = {
  __typename?: 'AssetRef';
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AutologinLinks = {
  __typename?: 'AutologinLinks';
  appsflyer_url?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use web_url instead. sso_url is a legacy field that encrypts a learnWorldsId. */
  sso_url?: Maybe<Scalars['String']['output']>;
  web_url?: Maybe<Scalars['String']['output']>;
};

export type AvailablePlan = {
  __typename?: 'AvailablePlan';
  availableLanguages: Array<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  contentFormat: ContentFormat;
  currentGoalId?: Maybe<Scalars['ID']['output']>;
  dayFormat: DayFormat;
  /** How many photos the album needs before it has a recap to play. */
  firstRecapPhotoMemoryCount: Scalars['Int']['output'];
  /** Whether this plan surfaces the mastery collection. True only for kids Day-flow plans; the client draws the collection tab from this, so a plan switch hides it without a config round-trip. */
  hasCollection: Scalars['Boolean']['output'];
  /** Whether this plan serves the rebuilt practice player. False means the shipped player, and the client must keep rendering it — false is also the answer for a plan the new player has not reached. A build without the new player never asks for this field. */
  hasNewPracticePlayer: Scalars['Boolean']['output'];
  /** Whether this plan offers photo memories to the viewer: the feature, the treatment and a Day-flow plan. */
  hasPhotoMemories: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /**
   * The onboarding this plan serves after purchase, in the caller's language.
   * Null means the app runs the flow it shipped with — no published definition,
   * not the step-by-step arm, or a plan whose format has no journey to introduce.
   */
  onboarding?: Maybe<PlanOnboarding>;
  /** The viewer's photo memories on this plan. */
  photoMemoryCount: Scalars['Int']['output'];
  startFlow?: Maybe<StartFlow>;
  /** Step-by-step: true when this user is served the single permanent-goal journey for this plan (the `step` arm plus a permanent goal authored on the plan). Sits alongside contentFormat/dayFormat so the client reads the serving mode directly instead of inferring it from the goal shape. */
  stepByStep: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type BlockContent = DayOutroContent | DoExtraContent | EducationalIntroContent | IntroContent | PracticeContent | TodaysFocusContent;

export enum BlockType {
  ActionPoints = 'ACTION_POINTS',
  DayOutro = 'DAY_OUTRO',
  DoExtra = 'DO_EXTRA',
  EducationalIntro = 'EDUCATIONAL_INTRO',
  Image = 'IMAGE',
  Insights = 'INSIGHTS',
  Intro = 'INTRO',
  Practice = 'PRACTICE',
  Recap = 'RECAP',
  Text = 'TEXT',
  TodaysFocus = 'TODAYS_FOCUS',
  Video = 'VIDEO',
  VideoTip = 'VIDEO_TIP'
}

/** A card game dealt for the viewer's child. */
export type CardGame = {
  __typename?: 'CardGame';
  /** A stable id for this deal, derived from its seed. */
  dealId: Scalars['ID']['output'];
  exerciseId: Scalars['ID']['output'];
  howToPlay?: Maybe<Array<CardGameHowToPlayStep>>;
  /** In order; the client never re-sorts it. */
  rounds: Array<CardGameRound>;
  tip?: Maybe<Scalars['String']['output']>;
};

/** One piece of card-game copy; kind names how the client renders it (e.g. idea, challenge, question, rule, go, move, pair). A move/pair block carries its steps in `items` instead of `title`/`text`. A `rule` block's line is in `title`, not `text` (a `go` block still uses `text`). */
export type CardGameBlock = {
  __typename?: 'CardGameBlock';
  items: Array<CardGameBlockItem>;
  kind: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** One step of a move sequence, or one half of a pair — a pair block's items alternate trigger, action, trigger, action… */
export type CardGameBlockItem = {
  __typename?: 'CardGameBlockItem';
  imageUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CardGameCard = {
  __typename?: 'CardGameCard';
  /** Drawn on the flipped card; non-empty means the card can be turned over. */
  back: Array<CardGameBlock>;
  /** Drawn on the card face. */
  front: Array<CardGameBlock>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type CardGameHowToPlayStep = {
  __typename?: 'CardGameHowToPlayStep';
  text: Scalars['String']['output'];
  /** Reserved: no step is authored with one yet, so this always resolves null today. */
  title?: Maybe<Scalars['String']['output']>;
};

/** One dealt round: an optional rule card and the cards played under it, in order — a phase's rule and the cards it governs are the same round. Either side may be absent (a trailing rule with no cards, or cards under no rule); a round with neither is never sent. In a game with a GO card, every dealt card is its own round and GO trails it in that same `cards`, never as `rule` and never opening a round on its own. */
export type CardGameRound = {
  __typename?: 'CardGameRound';
  /** The round's cards in play order. cards_per_deal counts these across the whole deal, except a GO card (identified by a single front block of kind go) — the client excludes it. */
  cards: Array<CardGameCard>;
  /** Stable within a deal and across re-reads of the same seed. */
  key: Scalars['ID']['output'];
  /** The round's rule card, when it has one: no imageUrl, its line in the `title` of a `front` block of kind rule, optionally followed by a `pair` block of that rule's trigger/action pairs. */
  rule?: Maybe<CardGameCard>;
};

/** A family of the design's card palette, Card 1 to Card 7, not a shade: the client draws every tone from it. */
export enum CardPaletteColor {
  Card_1 = 'CARD_1',
  Card_2 = 'CARD_2',
  Card_3 = 'CARD_3',
  Card_4 = 'CARD_4',
  Card_5 = 'CARD_5',
  Card_6 = 'CARD_6',
  Card_7 = 'CARD_7'
}

export type ChainDay = {
  __typename?: 'ChainDay';
  /** 1-based position in PLAN order, not the per-segment number. */
  number: Scalars['Int']['output'];
  /**
   * The day's visible practices, counted after the reader's experiment arm has
   * filtered them — the same number the day screen stacks its cards from.
   */
  practiceCount: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * The catalogue price a checkout by price id charges: the buyer country's price
 * of the plan and currency the landing named.
 */
export type CheckoutChargedPrice = {
  __typename?: 'CheckoutChargedPrice';
  /** The first charge, in units of the currency: 49.99 USD, 6900 JPY. */
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  priceId: Scalars['String']['output'];
};

export type CheckoutSolidByPriceInput = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  locale?: InputMaybe<Locale>;
  /**
   * The catalogue price the landing showed. Checkout sells its plan and currency
   * at the buyer country's price, the one SolidGate charges; the response names it.
   */
  priceId: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSolidInput = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  locale?: InputMaybe<Locale>;
  pricingPlanAlias: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSolidPayPalByPriceInput = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  locale?: InputMaybe<Locale>;
  /**
   * The catalogue price the landing showed. Checkout sells its plan and currency
   * at the buyer country's price, the one SolidGate charges; the response names it.
   */
  priceId: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutSolidPayPalInput = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  locale?: InputMaybe<Locale>;
  pricingPlanAlias: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
  visitorId?: InputMaybe<Scalars['String']['input']>;
};

export type Collection = {
  __typename?: 'Collection';
  /** Collected only, highest tier first and then most recently collected. A card the user has never met is an empty slot with nothing to send. */
  cards: Array<CollectionCard>;
  hasPendingChanges: Scalars['Boolean']['output'];
  ladder: Array<MasteryTierThreshold>;
  pendingChanges: Array<MasteryChange>;
  summary: CollectionSummary;
};

export type CollectionCard = {
  __typename?: 'CollectionCard';
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  equipment: Array<Scalars['String']['output']>;
  exerciseId: Scalars['ID']['output'];
  favourite: Scalars['Boolean']['output'];
  format: ExerciseFormat;
  /** Null at the top tier. */
  nextTier?: Maybe<Scalars['Int']['output']>;
  progress: Scalars['Int']['output'];
  /** What the card is filed under. Empty for an exercise nobody has tagged yet. */
  tags: Array<CollectionTag>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  tier: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** Null at the top tier. */
  toNextTier?: Maybe<Scalars['Int']['output']>;
};

export type CollectionCardExercise = {
  __typename?: 'CollectionCardExercise';
  card: CollectionCard;
  /** The variation the child's context picks, in the shape the day-flow player already takes. */
  content: Array<PracticeExercise>;
};

export type CollectionSummary = {
  __typename?: 'CollectionSummary';
  /** One entry per tag some exercise carries, whatever this wall holds. Render the filter row from this and count nothing locally. These do not add up to `total` in either direction and are not meant to: an exercise with no tag is counted in neither, one with two tags is counted in both. */
  byTag: Array<CollectionTagCount>;
  byTier: Array<MasteryTierCount>;
  collected: Scalars['Int']['output'];
  /** Everything the user's own plans can hand out, plus what they already collected there — the denominator of "23 of 39". Kids and adult plans are counted apart. */
  total: Scalars['Int']['output'];
};

export type CollectionTag = {
  __typename?: 'CollectionTag';
  /** The stable key the client keys a tag's colour off; `title` is localised and must not be keyed on. */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type CollectionTagCount = {
  __typename?: 'CollectionTagCount';
  /** Exercises carrying this tag that this user could collect. */
  count: Scalars['Int']['output'];
  tag: CollectionTag;
};

export type CompleteDayResponse = {
  __typename?: 'CompleteDayResponse';
  day: Day;
  /**
   * Compliance / progress check-in survey targeted at this user. Returned at most
   * once per user per survey: serving it records the survey as shown, so the client
   * can present it optimistically without a confirmation round-trip.
   */
  pendingSurvey?: Maybe<Survey>;
  streakPayload?: Maybe<StreakPayload>;
  userProgress: UserDayProgress;
  userReviewPayload?: Maybe<UserReviewPayload>;
};

export type CompletePracticePayload = {
  __typename?: 'CompletePracticePayload';
  /** Collection: ask for a star rating now? True on the first video or card-game practice completed that day; with the practiceFeedbackEveryPractice flag, on every practice's first completion in the day. Submit the rating via ratePractice. */
  collectFeedback: Scalars['Boolean']['output'];
  /**
   * Compliance / progress check-in survey targeted at this user. Same serve-once
   * semantics as completeDay: serving it records the survey as shown, so it appears
   * at most once per user per survey (on the first qualifying practice).
   */
  pendingSurvey?: Maybe<Survey>;
  /** Present when the user should be asked for a photo now. Absent means do not ask. */
  photoPrompt?: Maybe<PhotoPrompt>;
  /** Floor celebration — present only on the call that first counts the day. */
  streakPayload?: Maybe<StreakPayload>;
  /** Display: prefetched store routing (Trustpilot / App Store) for the happy path. Only on the day's first video or card-game practice, whatever the flag, and further limited by the existing review cooldown. */
  userReviewPayload?: Maybe<UserReviewPayload>;
};

/**
 * What the comeback completion hands back. Deliberately no `userReviewPayload`: the client's
 * completion sequence shows a step only when it has something to show, so the rating never
 * appears after a comeback — and the day's one rating slot stays free for a later practice.
 */
export type CompleteReturnPracticePayload = {
  __typename?: 'CompleteReturnPracticePayload';
  /** The day the comeback was credited to. */
  dayId: Scalars['ID']['output'];
  /** Floor celebration — present only on the call that first counts the day. */
  streakPayload?: Maybe<StreakPayload>;
};

export enum ContentFormat {
  Basic = 'BASIC',
  Journey = 'JOURNEY'
}

/** Named, not ordered: each lands on a fixed waypoint the client draws. */
export type CurveCallouts = {
  __typename?: 'CurveCallouts';
  end: Scalars['String']['output'];
  mid: Scalars['String']['output'];
  start: Scalars['String']['output'];
};

export type Day = {
  __typename?: 'Day';
  blocks: Array<DayBlock>;
  canonicalId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  segmentId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type DayBlock = {
  __typename?: 'DayBlock';
  author?: Maybe<Scalars['String']['output']>;
  canonicalId: Scalars['ID']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  content?: Maybe<BlockContent>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  points?: Maybe<Array<Point>>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: BlockType;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
  videoMetadata?: Maybe<VideoMetadata>;
};

/**
 * How far the user has progressed through a day's practices. Derived from completed
 * practices, never stored: COUNTED once at least one practice is done but not all of
 * them (the day advances the journey), DEEPENED once every practice is done. A
 * single-practice day deepens the moment its one practice is complete.
 */
export enum DayCompletionState {
  Counted = 'COUNTED',
  Deepened = 'DEEPENED',
  NotStarted = 'NOT_STARTED'
}

/**
 * How a plan's days are structured and completed. VERTICAL = legacy whole-day flow;
 * FLOW = the new day-of-practices flow (per-practice completion). Existing plans are
 * VERTICAL.
 */
export enum DayFormat {
  Flow = 'FLOW',
  Vertical = 'VERTICAL'
}

export type DayOutroContent = {
  __typename?: 'DayOutroContent';
  shortText: Scalars['String']['output'];
};

export type DayPractice = {
  __typename?: 'DayPractice';
  durationMinutes: Scalars['Int']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type DayWithProgress = {
  __typename?: 'DayWithProgress';
  blocks: Array<DayBlock>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  /** This completion's photo, once added. */
  photoMemory?: Maybe<PhotoMemory>;
  /** Visible PRACTICE blocks in the day — the cards the client stacks on the journey view. */
  practiceCount: Scalars['Int']['output'];
  segmentId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  userProgress?: Maybe<UserDayProgress>;
};

/** Discovery item that upsells a PDF stored in GCS (leaply-files) */
export type DiscoveryItem = {
  __typename?: 'DiscoveryItem';
  canonicalId: Scalars['String']['output'];
  /** Internal code identifying the type of guide/upsell */
  code?: Maybe<DiscoveryItemCode>;
  content: Array<Text>;
  createdAt: Scalars['DateTime']['output'];
  /** When this item is the quiz-featured one, this carries its featured copy; otherwise the normal description. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  planId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  /** Stable item identifier the quiz targets via featuredDiscover */
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** URL path to the PDF (e.g. gs://leaply-files/path/file.pdf) */
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Discovery item codes identifying different types of guides/upsells */
export enum DiscoveryItemCode {
  DeepSleep = 'DEEP_SLEEP',
  Nutrition = 'NUTRITION',
  Posture = 'POSTURE',
  PrintablePlan = 'PRINTABLE_PLAN',
  StressAndAnxiety = 'STRESS_AND_ANXIETY'
}

export type DiscoveryItemCreateInput = {
  canonicalId: Scalars['String']['input'];
  code?: InputMaybe<DiscoveryItemCode>;
  content: Array<TextInput>;
  description: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type DiscoveryItemUpdateInput = {
  code?: InputMaybe<DiscoveryItemCode>;
  content?: InputMaybe<Array<TextInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type DiscoveryItemsResponse = {
  __typename?: 'DiscoveryItemsResponse';
  featured: Array<DiscoveryItem>;
  items: Array<DiscoveryItem>;
};

export type DoExtraContent = {
  __typename?: 'DoExtraContent';
  intro?: Maybe<Scalars['String']['output']>;
  practices: Array<DoExtraPractice>;
  title: Scalars['String']['output'];
};

export type DoExtraExercise = {
  __typename?: 'DoExtraExercise';
  /** The dealt game, present only when format is CARD_GAME. */
  cardGame?: Maybe<CardGame>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  format: ExerciseFormat;
  /** The planned game, present only when format is a game played through it (WHEEL). */
  game?: Maybe<Game>;
  id: Scalars['ID']['output'];
  nameAudioUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Step title from the shared library exercise (localized off exercise_{id}_title). */
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DoExtraPractice = {
  __typename?: 'DoExtraPractice';
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  equipment: Array<Scalars['String']['output']>;
  exercises: Array<DoExtraExercise>;
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  outroLine?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  voicePrefixes?: Maybe<PracticeVoicePrefixes>;
  /** The same text as PracticeContent.whyItWorks, from the library practice. */
  whyItWorks?: Maybe<Scalars['String']['output']>;
};

export type EducationalBlock = {
  __typename?: 'EducationalBlock';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: BlockType;
  url?: Maybe<Scalars['String']['output']>;
};

export type EducationalIntroContent = {
  __typename?: 'EducationalIntroContent';
  blocks: Array<EducationalBlock>;
  title: Scalars['String']['output'];
};

export enum ExerciseFormat {
  /** A game played by dealing a shuffled deck of cards rather than steps. */
  CardGame = 'CARD_GAME',
  HorizontalVideo = 'HORIZONTAL_VIDEO',
  Image = 'IMAGE',
  Text = 'TEXT',
  VerticalVideo = 'VERTICAL_VIDEO',
  VerticalVideoInstructions = 'VERTICAL_VIDEO_INSTRUCTIONS',
  /** A game played on a wheel of two rings: the item (what) and the way (how). */
  Wheel = 'WHEEL'
}

export type ExerciseReplayPayload = {
  __typename?: 'ExerciseReplayPayload';
  change: MasteryChange;
};

export type FbPixelInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  eventSourceURL: Scalars['String']['input'];
  fbc?: InputMaybe<Scalars['String']['input']>;
  fbp?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FactListBlock = {
  __typename?: 'FactListBlock';
  facts: Array<OnboardingFact>;
  id: Scalars['String']['output'];
};

/**
 * One CMS-authored walkthrough card for one feature.
 *
 * ONE RECORD IS ONE SCREEN: each feature gets a single card, and the flow the user
 * walks is several features' cards stitched together in `featureOnboardings` order,
 * each gated by its own arm. There is no step level.
 */
export type FeatureOnboarding = {
  __typename?: 'FeatureOnboarding';
  body?: Maybe<Scalars['String']['output']>;
  /** How many plan cards this card renders. Ignored when `contentSource` is null. */
  contentLimit: Scalars['Int']['output'];
  /** Null for a card whose content is entirely CMS-authored. */
  contentSource?: Maybe<FeatureOnboardingContentSource>;
  /** Small label above the title, e.g. "HAVE YOU TRIED THIS YET?". */
  eyebrow?: Maybe<Scalars['String']['output']>;
  /**
   * Stable identifier for the feature this explains, e.g. `practice_swap`. Report
   * analytics under THIS, never under the position in the list (which moves when
   * the flow is reordered) or the title (which is translated and edited).
   */
  key: Scalars['String']['output'];
  /** Which feature card the app draws behind the copy. */
  layout: FeatureOnboardingLayout;
  /**
   * The answers under the copy, in display order.
   *
   * Picking one advances the flow, which is why a card has no CTA label. The answer
   * is not sent back to us: record it in analytics from the client, using the
   * option's `id`, never its translated `title`.
   */
  options: Array<FeatureOnboardingOption>;
  /**
   * The opening days of the user's own plan, when `contentSource` is PLAN_DAYS;
   * empty otherwise. Read as content, not progress — a user who has completed
   * nothing still gets real cards — so no separate fallback content exists. Also
   * empty when the user has no plan.
   */
  planDays: Array<FeatureOnboardingPlanDay>;
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The first question's answers ("have you tried this yet?"), in display order.
   * Picking one advances to the second question.
   */
  triedOptions: Array<FeatureOnboardingOption>;
};

/** Where a card's live content comes from. Values are additive; ignore unknown ones. */
export enum FeatureOnboardingContentSource {
  PlanDays = 'PLAN_DAYS'
}

/**
 * The feature cards a walkthrough can draw. Server-driven, so it lives here
 * rather than in each client: Apollo generates it into both, and an older build
 * receiving a newer value degrades safely (Swift GraphQLEnum, Kotlin UNKNOWN__)
 * instead of crashing.
 *
 * One value per FEATURE CARD, not per screen shape. The shapes are identical
 * across features — eyebrow, heading, description, answers — so what actually
 * varies is the app screenshot behind the copy, and that asset ships in the app
 * because it has to match the build. Naming the card is therefore how the server
 * tells the client which mockup to draw.
 *
 * Consequence: a new feature card needs an enum value AND a client release. That
 * is not a cost this enum adds — a card the app cannot draw is unusable either way.
 *
 * PROVISIONAL until the client implementers confirm. Renaming is cheap: `layout`
 * is purely presentational and anchors nothing (translations hang on the row id,
 * analytics on the feature key and option ids).
 */
export enum FeatureOnboardingLayout {
  CollectionCard = 'COLLECTION_CARD',
  DoExtraCard = 'DO_EXTRA_CARD',
  PracticeCard = 'PRACTICE_CARD',
  RemindersCard = 'REMINDERS_CARD',
  SwapCard = 'SWAP_CARD',
  TodayCard = 'TODAY_CARD'
}

/** One answer the walkthrough offers under every card. */
export type FeatureOnboardingOption = {
  __typename?: 'FeatureOnboardingOption';
  /**
   * Stable identifier, e.g. `it_helped`. This is the value to record in analytics:
   * `title` is translated, so reporting on it would split one answer across every
   * locale and break on the first wording change.
   */
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** One day of the user's plan, previewed. Localized like any other plan content. */
export type FeatureOnboardingPlanDay = {
  __typename?: 'FeatureOnboardingPlanDay';
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** 1-based position in plan order, not the day's number inside its segment. */
  number: Scalars['Int']['output'];
  practiceDescription?: Maybe<Scalars['String']['output']>;
  /** The day's first practice; null on a day that has none. */
  practiceTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** A game planned for the viewer's child. Card games keep their own `cardGame` field. */
export type Game = WheelGame;

export type Goal = {
  __typename?: 'Goal';
  description?: Maybe<Scalars['String']['output']>;
  goalTakeaways?: Maybe<Array<GoalTakeaway>>;
  id: Scalars['ID']['output'];
  milestone?: Maybe<Milestone>;
  number: Scalars['Int']['output'];
  segments: Array<SegmentWithProgress>;
  teaser?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userProgress?: Maybe<UserGoalProgress>;
};

/** The plan's permanent goal — the one authored as goal number 0. */
export type GoalBadgeBlock = {
  __typename?: 'GoalBadgeBlock';
  goalTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type GoalTakeaway = {
  __typename?: 'GoalTakeaway';
  doneTitle: Scalars['String']['output'];
  upcomingTitle: Scalars['String']['output'];
};

export type IntroContent = {
  __typename?: 'IntroContent';
  shortText: Scalars['String']['output'];
};

export type KidProfile = {
  __typename?: 'KidProfile';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LeadEligibilityInput = {
  email: Scalars['String']['input'];
  flow: Scalars['String']['input'];
};

export type LeadEligibilityResult = {
  __typename?: 'LeadEligibilityResult';
  eligible: Scalars['Boolean']['output'];
  reason?: Maybe<LeadIneligibilityReason>;
};

export enum LeadIneligibilityReason {
  ActiveSamePlanSubscription = 'ACTIVE_SAME_PLAN_SUBSCRIPTION'
}

export enum Locale {
  Ar = 'ar',
  Br = 'br',
  Co = 'co',
  Cs = 'cs',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Ja = 'ja',
  Pl = 'pl',
  Pt = 'pt',
  Tr = 'tr'
}

export type MarketingEventInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  eventName: MarketingEventType;
  eventSourceURL: Scalars['String']['input'];
  fbc: Scalars['String']['input'];
  fbp: Scalars['String']['input'];
  flow?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  ttclid?: InputMaybe<Scalars['String']['input']>;
  ttp?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketingEventType {
  InitiateCheckout = 'InitiateCheckout',
  Lead = 'Lead',
  PageView = 'PageView',
  Purchase = 'Purchase',
  StartQuiz = 'StartQuiz',
  ViewContent = 'ViewContent'
}

export type MasteryChange = {
  __typename?: 'MasteryChange';
  case: MasteryChangeCase;
  /** The completion that closed this span. Cards earned in one practice carry the same instant, so equal values are one ceremony and `pendingChanges` is ordered newest first. */
  completedAt: Scalars['DateTime']['output'];
  exerciseId: Scalars['ID']['output'];
  /** Progress last seen. */
  from: Scalars['Int']['output'];
  nextTier?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  tier: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** Progress now. */
  to: Scalars['Int']['output'];
  toNextTier?: Maybe<Scalars['Int']['output']>;
};

export type MasteryChangeAck = {
  exerciseId: Scalars['ID']['input'];
  /** The `to` of the change that was shown — echoed so a rep landing in between is not swallowed. */
  seenProgress: Scalars['Int']['input'];
};

export enum MasteryChangeCase {
  Grew = 'GREW',
  Reinforced = 'REINFORCED',
  TierUp = 'TIER_UP',
  Unlocked = 'UNLOCKED'
}

export type MasteryTierCount = {
  __typename?: 'MasteryTierCount';
  count: Scalars['Int']['output'];
  /** Share of `collected`, largest-remainder so the set sums to 100. */
  percent: Scalars['Int']['output'];
  tier: Scalars['Int']['output'];
};

export type MasteryTierThreshold = {
  __typename?: 'MasteryTierThreshold';
  minProgress: Scalars['Int']['output'];
  tier: Scalars['Int']['output'];
};

export type Milestone = {
  __typename?: 'Milestone';
  celebrationBody?: Maybe<Scalars['String']['output']>;
  celebrationTitle?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  milestoneResult?: Maybe<Scalars['String']['output']>;
  milestoneType: MilestoneType;
  nextUp?: Maybe<MilestoneNextUp>;
  title: Scalars['String']['output'];
};

export type MilestoneNextUp = {
  __typename?: 'MilestoneNextUp';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum MilestoneType {
  Goal = 'GOAL',
  Week = 'WEEK'
}

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeMasteryChanges: Scalars['Boolean']['output'];
  addUserNewPlan: Access;
  checkoutSolid: SolidPaymentIntent;
  checkoutSolidByPrice: SolidPaymentIntentByPrice;
  checkoutSolidPayPal: SolidPayPalPaymentIntent;
  checkoutSolidPayPalByPrice: SolidPayPalPaymentIntentByPrice;
  /** After a game: the album's photo count of the recap its photos reached, now offered; null when there is none to offer. Game photo uploads never offer it themselves. */
  claimPhotoMemoryRecapOffer?: Maybe<Scalars['Int']['output']>;
  completeDay: CompleteDayResponse;
  completeOnboarding: Scalars['Boolean']['output'];
  /** New-day flow: complete a single practice. The day auto-counts on the first completed practice (floor) and deepens once all are done (ceiling). */
  completePractice: CompletePracticePayload;
  /**
   * Completes the return flow's comeback practice. The client sends only the plan and the
   * practice it rendered; the SERVER picks the day — the outstanding offer the decide landed
   * for this user on the plan — and returns it as `dayId`. The echoed `practiceId` must match
   * what that offer recorded (what was actually rendered), even after the plan's pick has since
   * moved. Idempotent: a retry hits the same occurrence key and changes nothing.
   */
  completeReturnPractice: CompleteReturnPracticePayload;
  createUserDay: UserDayProgress;
  createUserSegment: UserSegmentProgress;
  /** "Not now" on a recap offer. Someone who never watched a recap stops being offered one after two. */
  declinePhotoMemoryRecap: Scalars['Boolean']['output'];
  declineReview: Scalars['Boolean']['output'];
  /** Removes one photo memory and its files. True when it is gone, including when it was already gone. */
  deletePhotoMemory: Scalars['Boolean']['output'];
  fbPixel: Scalars['Boolean']['output'];
  getAutologinLinks: AutologinLinks;
  getOrderStatusByPaymentIntentId?: Maybe<Scalars['Int']['output']>;
  getUserByEmail?: Maybe<UserResponse>;
  /** Records that the user played a review-only Do Extra practice. `sourceId` is the value the DoExtraPractice served (the library practice, or its source block on older content). Idempotent; never counts or deepens the day. */
  markDoExtraCompleted: Scalars['Boolean']['output'];
  /**
   * Lifecycle-experiment EXPOSURE report. Sent ONCE per plan entry, by BOTH arms,
   * at the moment the client knows what it rendered.
   *
   * This is the ONLY exposure signal, and it replaces two earlier calls: the
   * former confirmPlanEntry mutation (now removed — it never shipped to a
   * released client), and the render-time
   * setStartFlowStatus(flowType: returnFlow, status: shown) call, which clients
   * should stop sending. Keep using setStartFlowStatus for `completed` and for
   * everything about onboarding.
   *
   * Send it ONCE when the user has reached the surface and it has done its work —
   * the flow for the served arm, the plain plan screen for everyone else. Both
   * arms, the same moment, one call site.
   *
   * Take `experimentName` and `planId` from the surface's entry in `/config`'s
   * `lifecycleExperiments` (today `planOpened`), and send it only when the plan
   * opened IS that entry's `planId`. An entry with no `planId` is not plan-scoped:
   * report it wherever it applies.
   *
   * `arm` echoes what the SERVE ANSWER said — for the return flow, `return` when
   * `startFlow.type` was `returnFlow` or `returnFlowDormant` and `control` otherwise.
   * Never what the client managed to render: only one arm can fail a render, so
   * gating on it would filter that arm on device health. Optional, and omitting it is
   * always safe — the server then trusts its own allocation, which is what every
   * build before this argument existed does.
   *
   * Do NOT gate on whether the treatment rendered — only one arm can fail that, so
   * it would filter that arm on device health and network, which correlate with the
   * retention being measured. Which plan was opened is not such a condition.
   *
   * Fire-and-forget: the response is always true and carries no meaning.
   */
  markExperimentExposed: Scalars['Boolean']['output'];
  /** A recap was played; offers keep coming at every count. */
  markPhotoMemoryRecapWatched: Scalars['Boolean']['output'];
  marketingEvent: Scalars['Boolean']['output'];
  oneClickCheckout: OneClickCheckoutResponse;
  oneClickCheckoutByLssvmp: OneClickCheckoutResponse;
  /**
   * Atomic one-dollar-charge: eligibility gate + GrowthBook flag eval + charge,
   * all server-side. Replaces the CF-side split between eligibility/flag checks
   * and the downstream charge mutation. Safe to call for every device — the BE
   * decides the outcome.
   */
  oneDollarCharge: OneDollarChargeResult;
  openUserSegment: UserSegmentProgress;
  rateDay: CompleteDayResponse;
  ratePractice: RatePracticePayload;
  replayExercise: ExerciseReplayPayload;
  reviewAccepted: Scalars['Boolean']['output'];
  setActivePlan: Scalars['String']['output'];
  setCourseForUser: Scalars['Boolean']['output'];
  /** Named state, not a toggle: a double tap on a bad connection cannot flip the heart back. */
  setFavourite: Scalars['Boolean']['output'];
  setLanguage: Scalars['Boolean']['output'];
  /**
   * Records why a user declined to continue in the return flow. Append-only: each
   * flow run adds an entry, so a user greeted again later builds a history. Repeat
   * submissions on the same day collapse onto that day's entry, so a retry after a
   * network failure is safe. Independent of setStartFlowStatus — neither requires
   * the other, in either order. freeformText is only ever sent with reason `other`
   * and is capped at 1000 characters; anything else is rejected.
   */
  setStartFlowDeclineFeedback: Scalars['Boolean']['output'];
  setStartFlowStatus: Scalars['Boolean']['output'];
  signUpWithEmailAndPassword: Access;
  /** Records that the user declined the photo prompt for this day. Repeating it changes nothing. */
  skipPhotoPrompt: Scalars['Boolean']['output'];
  /** @deprecated Use webAutoLogin instead. ssoByLearnWorldsId is a legacy mutation that will be removed. */
  ssoByLearnWorldsId: Access;
  startPlan: UserPlanProgress;
  startPlanForUser: UserPlanProgress;
  submitSurveyAnswer: SubmitSurveyAnswerPayload;
  /**
   * Serves a different library practice in one day's practice slot, for this user only.
   * Plan content is untouched, and a later swap replaces this one. `practiceId` is the
   * block id; `toPracticeId` must be a practice the day can offer — the set
   * `practiceSwapAlternatives` draws from.
   */
  swapPractice: SwapPracticePayload;
  updateDiscoveryItem: DiscoveryItem;
  /** Same contract as updateUserProfile, for the kid section. */
  updateKidProfile: User;
  updateUserDayOpenOn: UserDayProgress;
  /**
   * An absent field is left alone. Clearing a value is not supported — no drawer
   * offers it — so null and absent are the same instruction. Returns the whole
   * User so a client never has to refetch after saving.
   */
  updateUserProfile: User;
  updateUserSegmentOpenOn: UserSegmentProgress;
  webAutoLogin: WebAutoLoginResponse;
};


export type MutationAcknowledgeMasteryChangesArgs = {
  acks: Array<MasteryChangeAck>;
};


export type MutationAddUserNewPlanArgs = {
  input: AddUserNewPlanInput;
};


export type MutationCheckoutSolidArgs = {
  input: CheckoutSolidInput;
};


export type MutationCheckoutSolidByPriceArgs = {
  input: CheckoutSolidByPriceInput;
};


export type MutationCheckoutSolidPayPalArgs = {
  input: CheckoutSolidPayPalInput;
};


export type MutationCheckoutSolidPayPalByPriceArgs = {
  input: CheckoutSolidPayPalByPriceInput;
};


export type MutationClaimPhotoMemoryRecapOfferArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationCompleteDayArgs = {
  dayId: Scalars['ID']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCompleteOnboardingArgs = {
  key: Scalars['String']['input'];
};


export type MutationCompletePracticeArgs = {
  dayId: Scalars['ID']['input'];
  practiceId: Scalars['ID']['input'];
};


export type MutationCompleteReturnPracticeArgs = {
  planId: Scalars['ID']['input'];
  practiceId: Scalars['ID']['input'];
};


export type MutationCreateUserDayArgs = {
  dayId: Scalars['ID']['input'];
  openOn: Scalars['DateTime']['input'];
};


export type MutationCreateUserSegmentArgs = {
  openOn: Scalars['DateTime']['input'];
  segmentId: Scalars['ID']['input'];
};


export type MutationDeclinePhotoMemoryRecapArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationDeclineReviewArgs = {
  dayId?: InputMaybe<Scalars['ID']['input']>;
  reviewType: ReviewType;
};


export type MutationDeletePhotoMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFbPixelArgs = {
  input: FbPixelInput;
};


export type MutationGetAutologinLinksArgs = {
  email: Scalars['String']['input'];
};


export type MutationGetOrderStatusByPaymentIntentIdArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationGetUserByEmailArgs = {
  input: UserInput;
};


export type MutationMarkDoExtraCompletedArgs = {
  dayId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
};


export type MutationMarkExperimentExposedArgs = {
  arm?: InputMaybe<Scalars['String']['input']>;
  experimentName: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkPhotoMemoryRecapWatchedArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationMarketingEventArgs = {
  input: MarketingEventInput;
};


export type MutationOneClickCheckoutArgs = {
  input: OneClickCheckout;
};


export type MutationOneClickCheckoutByLssvmpArgs = {
  input: OneClickCheckout;
};


export type MutationOneDollarChargeArgs = {
  input: OneDollarChargeInput;
};


export type MutationOpenUserSegmentArgs = {
  openOn: Scalars['DateTime']['input'];
  segmentId: Scalars['ID']['input'];
};


export type MutationRateDayArgs = {
  dayId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  reviewType?: InputMaybe<ReviewType>;
};


export type MutationRatePracticeArgs = {
  dayId: Scalars['ID']['input'];
  practiceId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
};


export type MutationReplayExerciseArgs = {
  exerciseId: Scalars['ID']['input'];
  replayId: Scalars['ID']['input'];
};


export type MutationReviewAcceptedArgs = {
  reviewType: ReviewType;
};


export type MutationSetActivePlanArgs = {
  planId: Scalars['ID']['input'];
};


export type MutationSetCourseForUserArgs = {
  input: SetCourseForUser;
};


export type MutationSetFavouriteArgs = {
  exerciseId: Scalars['ID']['input'];
  favourite: Scalars['Boolean']['input'];
};


export type MutationSetLanguageArgs = {
  language: Locale;
};


export type MutationSetStartFlowDeclineFeedbackArgs = {
  flowType: StartFlowType;
  freeformText?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  reason: StartFlowDeclineReason;
};


export type MutationSetStartFlowStatusArgs = {
  flowType: StartFlowType;
  planId: Scalars['ID']['input'];
  status: StartFlowStatus;
};


export type MutationSignUpWithEmailAndPasswordArgs = {
  input: SignUpWithEmailAndPasswordInput;
};


export type MutationSkipPhotoPromptArgs = {
  dayId: Scalars['ID']['input'];
};


export type MutationSsoByLearnWorldsIdArgs = {
  input: SsoByLearnWorldsIdInput;
};


export type MutationStartPlanArgs = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  planId: Scalars['ID']['input'];
  purchasedAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationStartPlanForUserArgs = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  planId: Scalars['ID']['input'];
  purchasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationSubmitSurveyAnswerArgs = {
  input: SubmitSurveyAnswerInput;
};


export type MutationSwapPracticeArgs = {
  dayId: Scalars['ID']['input'];
  practiceId: Scalars['ID']['input'];
  reason: PracticeSwapReason;
  toPracticeId: Scalars['ID']['input'];
};


export type MutationUpdateDiscoveryItemArgs = {
  id: Scalars['ID']['input'];
  input: DiscoveryItemUpdateInput;
};


export type MutationUpdateKidProfileArgs = {
  input: UpdateKidProfileInput;
};


export type MutationUpdateUserDayOpenOnArgs = {
  dayId: Scalars['ID']['input'];
  openOn: Scalars['DateTime']['input'];
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserSegmentOpenOnArgs = {
  openOn: Scalars['DateTime']['input'];
  segmentId: Scalars['ID']['input'];
};


export type MutationWebAutoLoginArgs = {
  input: WebAutoLoginInput;
};

export type OnboardingFact = {
  __typename?: 'OnboardingFact';
  icon: AssetRef;
  /** Its own identity, so removing a sibling never hands this one someone else's copy. */
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type OneClickCheckout = {
  alias: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
};

export type OneClickCheckoutResponse = {
  __typename?: 'OneClickCheckoutResponse';
  message?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for the consolidated one-dollar-charge mutation: the BE performs the
 * eligibility gate, evaluates the GrowthBook rollout flag against deviceId,
 * and — if both pass — executes the charge. The cloud function just stores
 * paymentIntents and calls this at process-time; it owns no decision logic.
 */
export type OneDollarChargeInput = {
  alias: Scalars['String']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
  urlParams: Scalars['String']['input'];
};

/**
 * Unified result of a one-dollar-charge attempt.
 *
 *   status = 'charged' → payment succeeded; orderId is populated.
 *   status = 'skipped' → ineligible or control arm; reason describes why.
 *                        Caller should NOT schedule a refund.
 *   status = 'error'   → charge attempt failed; message carries the detail.
 *                        Caller should NOT schedule a refund.
 *
 * Possible `reason` values when status = 'skipped':
 *   'not_visa' | 'not_tokenized_or_applepay' | 'missing_transaction'
 *   | 'unsupported_payment_method'   -- PayPal / APM orders
 *   | 'blocked_currency' | 'blocked_bank' | 'prepaid_card'
 *   | 'control_group'                -- device bucketed out of the experiment
 */
export type OneDollarChargeResult = {
  __typename?: 'OneDollarChargeResult';
  message?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type PhotoMemory = {
  __typename?: 'PhotoMemory';
  createdAt: Scalars['DateTime']['output'];
  dayId: Scalars['ID']['output'];
  /** As the plan shows it, resolved on read. */
  dayNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Signed, stable within an hour. */
  imageUrl: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** Null when the practice has left the library. */
  practiceTitle?: Maybe<Scalars['String']['output']>;
  segmentId: Scalars['ID']['output'];
  /** As the plan shows it, resolved on read. Null when the segment has left the plan. */
  segmentNumber?: Maybe<Scalars['Int']['output']>;
  segmentTitle?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
};

export type PhotoMemoryRecap = {
  __typename?: 'PhotoMemoryRecap';
  /** The track the recap plays under its slides; a replay of the same recap plays the same one. */
  musicUrl: Scalars['String']['output'];
  /** The photos without a slide, oldest first, at most 30 of them. */
  pile: Array<PhotoMemory>;
  /** How many photos the pile stands for; it can exceed the prints in `pile`. */
  pileCount: Scalars['Int']['output'];
  planId: Scalars['ID']['output'];
  /** The photos with a slide of their own, in the order they play. */
  slides: Array<PhotoMemoryRecapSlide>;
  stats: PhotoMemoryRecapStats;
};

export enum PhotoMemoryRecapScope {
  /** Played from the album: the first and the latest photos, and the rest spread over time. */
  All = 'ALL',
  /** Offered after a save that reaches a recap count: the photos since the last count, and the first one. */
  New = 'NEW'
}

export type PhotoMemoryRecapSlide = {
  __typename?: 'PhotoMemoryRecapSlide';
  /** The album's very first photo, played before the new ones as where it started. */
  isThrowback: Scalars['Boolean']['output'];
  photoMemory: PhotoMemory;
};

export type PhotoMemoryRecapStats = {
  __typename?: 'PhotoMemoryRecapStats';
  /** Authored durations of the plan practices completed on those days. */
  minutesPractised: Scalars['Int']['output'];
  /** Every photo in the album. */
  photoMemoryCount: Scalars['Int']['output'];
  /** The plan's days completed in the current run. */
  stepsTogether: Scalars['Int']['output'];
};

export type PhotoPrompt = {
  __typename?: 'PhotoPrompt';
  /** Which screen asks. The apps render it as given; an unknown value reads as ADULT_INTRO. */
  variant: PhotoPromptVariant;
};

export enum PhotoPromptVariant {
  /** No photo on the plan yet, every other plan. */
  AdultIntro = 'ADULT_INTRO',
  /** No photo on the plan yet, kids framing. */
  KidsIntro = 'KIDS_INTRO',
  /** The plan already has photos: the string of prints. */
  Nudge = 'NUDGE'
}

export type Plan = {
  __typename?: 'Plan';
  availableLanguages: Array<Scalars['String']['output']>;
  canonicalId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  contentFormat: ContentFormat;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  segments: Array<Segment>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type PlanOnboarding = {
  __typename?: 'PlanOnboarding';
  /** Send as `planType` on every onboarding event, instead of decoding the plan code. */
  analyticsPlanType: Scalars['String']['output'];
  /** Drawn by the shell on every step that has a button, not by a step. */
  ctaLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  steps: Array<PlanOnboardingStep>;
};

export type PlanOnboardingBlock = FactListBlock | GoalBadgeBlock | PracticeCardBlock | PracticeChainBlock | PracticeCurveBlock | PreparingBlock | SocialProofBlock;

export type PlanOnboardingStep = {
  __typename?: 'PlanOnboardingStep';
  /**
   * In draw order. A block whose type this build does not know must be SKIPPED and
   * the step kept: the shell owns the title, the progress bar and the button, so a
   * step that loses every block is thin, never a dead end.
   */
  blocks: Array<PlanOnboardingBlock>;
  /**
   * The step's identity AND its analytics screen name. Never the position.
   * The shipped spellings are the contract: welcome, goal, milestones,
   * revealPractice, dailyPractice, startDay. An id this build cannot draw is
   * skipped and the flow stays intact.
   */
  id: Scalars['String']['output'];
  /** Whether the shell's progress bar counts this step. Derive the bar's length from the steps that say true, not from the step count. */
  showsProgress: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  /**
   * One sentence a translator can rewrite freely. A phrase wrapped in double
   * asterisks is painted primary-600 — a colour, not bold — at most once per
   * sentence. May carry {{goalTitle}} {{goalNumber}} {{weekNumber}} {{segmentCount}}.
   */
  title?: Maybe<Scalars['String']['output']>;
};

export type PlanWithProgress = {
  __typename?: 'PlanWithProgress';
  availableLanguages: Array<Scalars['String']['output']>;
  canonicalId: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  contentFormat: ContentFormat;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  segments: Array<SegmentWithProgress>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userProgress?: Maybe<UserPlanProgress>;
  version: Scalars['String']['output'];
};

export type Point = {
  __typename?: 'Point';
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** One practice behind the user and one ahead, from the plan's first day. */
export type PracticeCardBlock = {
  __typename?: 'PracticeCardBlock';
  /** Struck through and ticked. Its duration and cover are not drawn. */
  completed: DayPractice;
  id: Scalars['String']['output'];
  /** The card: carries the duration and the cover. */
  next: DayPractice;
};

/** The plan's first four days. Absent entirely on a plan too short to fill them. */
export type PracticeChainBlock = {
  __typename?: 'PracticeChainBlock';
  days: Array<ChainDay>;
  id: Scalars['String']['output'];
};

export type PracticeCompletion = {
  __typename?: 'PracticeCompletion';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  isCompleted: Scalars['Boolean']['output'];
};

export type PracticeContent = {
  __typename?: 'PracticeContent';
  completion: PracticeCompletion;
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  equipment: Array<Scalars['String']['output']>;
  exercises: Array<PracticeExercise>;
  outroLine?: Maybe<Scalars['String']['output']>;
  swap: PracticeSwapState;
  tags: Array<PracticeTag>;
  title: Scalars['String']['output'];
  voicePrefixes?: Maybe<PracticeVoicePrefixes>;
  /** Why this practice helps the child, written for the parent. 1-2 short paragraphs split by an empty line. Null when not written. */
  whyItWorks?: Maybe<Scalars['String']['output']>;
};

export type PracticeCurveBlock = {
  __typename?: 'PracticeCurveBlock';
  callouts: CurveCallouts;
  goalCallout: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type PracticeExercise = {
  __typename?: 'PracticeExercise';
  /** The dealt game, present only when format is CARD_GAME. */
  cardGame?: Maybe<CardGame>;
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  equipment: Array<Scalars['String']['output']>;
  format: ExerciseFormat;
  /** The planned game, present only when format is a game played through it (WHEEL). */
  game?: Maybe<Game>;
  id: Scalars['ID']['output'];
  nameAudioUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PracticeSwapAlternative = {
  __typename?: 'PracticeSwapAlternative';
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  equipment: Array<Scalars['String']['output']>;
  exercises: Array<PracticeExercise>;
  outroLine?: Maybe<Scalars['String']['output']>;
  practiceId: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Why the user wants something else. Recorded with the swap; v1 does not match on it. */
export enum PracticeSwapReason {
  Different = 'DIFFERENT',
  Longer = 'LONGER',
  NewToMe = 'NEW_TO_ME',
  NoEquipment = 'NO_EQUIPMENT',
  Shorter = 'SHORTER'
}

export type PracticeSwapState = {
  __typename?: 'PracticeSwapState';
  available: Scalars['Boolean']['output'];
  reasons: Array<PracticeSwapReason>;
  swapped: Scalars['Boolean']['output'];
};

export type PracticeTag = {
  __typename?: 'PracticeTag';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type PracticeVoicePrefixes = {
  __typename?: 'PracticeVoicePrefixes';
  firstUrl: Scalars['String']['output'];
  lastUrl: Scalars['String']['output'];
  nextUrl: Scalars['String']['output'];
};

export type PreparingBlock = {
  __typename?: 'PreparingBlock';
  ctaHint: Scalars['String']['output'];
  durationLabel: Scalars['String']['output'];
  /**
   * How long the first day's first practice runs — the very practice this screen's
   * button opens. Read from the plan on every request, so it cannot drift from what
   * the day shows. Null when the plan has no first practice: draw the label and the
   * hint without a number rather than hiding the screen.
   */
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  /**
   * DEPRECATED in favour of `durationMinutes`, and kept only because shipped builds
   * select it — dropping it would fail their whole query, not just this field.
   * No longer authored: it is `durationMinutes` with a unit, so the two cannot disagree.
   */
  durationValue: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Stable and analytics-safe: the label may be reworded, the id may not. */
export type ProfileFieldOption = {
  __typename?: 'ProfileFieldOption';
  id: Scalars['String']['output'];
};

export type ProfileFieldOptions = {
  __typename?: 'ProfileFieldOptions';
  fitnessLevel: Array<ProfileFieldOption>;
  practiceTime: Array<ProfileFieldOption>;
};

export type Query = {
  __typename?: 'Query';
  /** Public, auth-aware app-update check, called by the client on launch. */
  appUpdate: AppUpdate;
  collectionCard?: Maybe<CollectionCardExercise>;
  country: Scalars['String']['output'];
  day?: Maybe<Day>;
  discoveryItem?: Maybe<DiscoveryItem>;
  /**
   * Fetch a discovery item by canonicalId or code.
   * If version is omitted, resolver should return the latest version.
   */
  discoveryItemByCanonicalOrCode?: Maybe<DiscoveryItem>;
  /**
   * Get discovery items with featured items based on time of day:
   * - Morning (4:01am-12pm) -> nutrition guide
   * - Midday (12:01pm-8pm) -> stress and anxiety relief guide
   * - Evening (8:01pm-4am) -> sleep guide
   * Can be filtered by locale.
   * The country code is automatically determined from the authenticated user's profile to determine the user's timezone for time-based featured items.
   */
  discoveryItems?: Maybe<DiscoveryItemsResponse>;
  /**
   * The published catalogue of feature walkthrough cards, in flow order, with copy
   * in the caller's language. Unlike `onboardingsToShow` these are never pushed —
   * the user opens the flow themselves — so nothing is tracked and the list does
   * not shrink after viewing.
   *
   * NOT filtered by audience. The client filters, on two conditions it alone can
   * answer: whether its build can draw this `layout`, and whether the user is in
   * the group that has the feature — the same condition that decides whether the
   * app renders the feature at all. A card whose layout is unknown must be skipped,
   * not rendered blank.
   *
   * Consequences for the client: the flow's own chrome (header, progress bar,
   * closing screen) has to derive from the FILTERED list, and the flow must not
   * open at all when nothing survives the filter.
   */
  featureOnboardings: Array<FeatureOnboarding>;
  leadEligibility: LeadEligibilityResult;
  me: User;
  myCollection: Collection;
  myDay?: Maybe<DayWithProgress>;
  myDays?: Maybe<Array<DayWithProgress>>;
  myGoal?: Maybe<Goal>;
  /** The viewer's photo memories on the plan, flat, by segment, day and createdAt. The app groups them. */
  myPhotoMemories: Array<PhotoMemory>;
  /** Null until the album holds 5 photos. */
  myPhotoMemoryRecap?: Maybe<PhotoMemoryRecap>;
  myPlan?: Maybe<PlanWithProgress>;
  myPlans?: Maybe<Array<PlanWithProgress>>;
  mySegment?: Maybe<SegmentWithProgress>;
  mySegments?: Maybe<Array<SegmentWithProgress>>;
  /** Onboardings still to play, in the order to play them. The client holds the screens. */
  onboardingsToShow: Array<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  plans: Array<Plan>;
  /**
   * Practices this slot can be swapped for, in the order to offer them. `practiceId` is
   * the block id, as in completePractice. Refuses whenever `PracticeContent.swap.available`
   * is false, so the sheet can never open on a slot the swap would then refuse.
   */
  practiceSwapAlternatives: Array<PracticeSwapAlternative>;
  /**
   * The selectable options for the profile drawers, ids only. Labels live in the
   * clients Crowdin keyed off the id, so rewording copy moves no value here.
   */
  profileFieldOptions: ProfileFieldOptions;
  regionCode?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Segment>;
  segments?: Maybe<Array<Segment>>;
  taxInfo?: Maybe<TaxInfo>;
  /**
   * Which notice to show on the given surface (NONE / SOFT / HARD) — today the "update
   * your payment method" screen for PayPal subscribers, which keeps returning until their
   * payment method is actually swapped. NOT idempotent for SOFT: answering SOFT records
   * that day's delivery, so call this only where the screen is actually presented.
   *
   * `peek: true` makes it idempotent by answering the DEAD-END only: HARD where the user
   * is dead-ended (which was never rationed anyway), NONE otherwise — a SOFT nudge needs a
   * claimed show, and a peek claims nothing. For surfaces that must block a dead-ended
   * user without being allowed to spend their day's nudge: a deep link or bookmark
   * straight into a route the nudge itself never renders on.
   */
  userNotice: UserNotice;
};


export type QueryCollectionCardArgs = {
  exerciseId: Scalars['ID']['input'];
};


export type QueryDayArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscoveryItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscoveryItemByCanonicalOrCodeArgs = {
  canonicalId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<DiscoveryItemCode>;
  locale?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDiscoveryItemsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeadEligibilityArgs = {
  input: LeadEligibilityInput;
};


export type QueryMyDayArgs = {
  dayId: Scalars['ID']['input'];
};


export type QueryMyDaysArgs = {
  segmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyGoalArgs = {
  goalId: Scalars['ID']['input'];
};


export type QueryMyPhotoMemoriesArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryMyPhotoMemoryRecapArgs = {
  planId: Scalars['ID']['input'];
  scope: PhotoMemoryRecapScope;
};


export type QueryMyPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryMySegmentArgs = {
  segmentId: Scalars['ID']['input'];
};


export type QueryMySegmentsArgs = {
  planId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlansArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPracticeSwapAlternativesArgs = {
  dayId: Scalars['ID']['input'];
  practiceId: Scalars['ID']['input'];
  reason: PracticeSwapReason;
};


export type QuerySegmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySegmentsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserNoticeArgs = {
  peek?: InputMaybe<Scalars['Boolean']['input']>;
  surface: UserNoticeSurface;
};

export type QuizAnswer = {
  __typename?: 'QuizAnswer';
  answer: Scalars['String']['output'];
  flow?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  step?: Maybe<Scalars['String']['output']>;
};

/**
 * One answer the acquisition funnel collected, as the funnel spells it. The
 * server owns every mapping — the encodings change per funnel variant, and one
 * place has to decide what `10MinDay` means.
 */
export type QuizAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type RatePracticePayload = {
  __typename?: 'RatePracticePayload';
  success: Scalars['Boolean']['output'];
};

/**
 * A library practice served whole, outside any day. Same shape as a swap alternative — it is
 * the same thing being previewed, a practice rather than a slot on a day.
 */
export type ReturnPractice = {
  __typename?: 'ReturnPractice';
  description?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  equipment: Array<Scalars['String']['output']>;
  exercises: Array<PracticeExercise>;
  outroLine?: Maybe<Scalars['String']['output']>;
  practiceId: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The line spoken before each exercise name, as PracticeContent.voicePrefixes. */
  voicePrefixes?: Maybe<PracticeVoicePrefixes>;
  /** The same text as PracticeContent.whyItWorks, from the library practice. */
  whyItWorks?: Maybe<Scalars['String']['output']>;
};

export type ReviewTracking = {
  __typename?: 'ReviewTracking';
  lastAskedAt?: Maybe<Scalars['DateTime']['output']>;
  nextAskAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ReviewType {
  Bbb = 'BBB',
  Native = 'NATIVE',
  Trustpilot = 'TRUSTPILOT'
}

export type SsoByLearnWorldsIdInput = {
  flow: Scalars['String']['input'];
  id: Scalars['String']['input'];
  locale: Locale;
  urlParams?: InputMaybe<Scalars['String']['input']>;
};

export type Segment = {
  __typename?: 'Segment';
  canonicalId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  days: Array<Day>;
  description?: Maybe<Scalars['String']['output']>;
  goalId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  milestone?: Maybe<Milestone>;
  number: Scalars['Int']['output'];
  plan?: Maybe<Plan>;
  planId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type SegmentWithProgress = {
  __typename?: 'SegmentWithProgress';
  days: Array<DayWithProgress>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  milestone?: Maybe<Milestone>;
  number: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  userProgress?: Maybe<UserSegmentProgress>;
};

export type SetCourseForUser = {
  flow: Scalars['String']['input'];
  id: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type SignUpPropertiesInput = {
  featuredDiscover?: InputMaybe<Scalars['String']['input']>;
};

export type SignUpWithEmailAndPasswordInput = {
  email: Scalars['String']['input'];
  isAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  paymentIntentId: Scalars['String']['input'];
  properties?: InputMaybe<SignUpPropertiesInput>;
  /**
   * What the funnel asked, as the funnel spells it — the name (the CHILD's on the
   * kids funnels), the daily practice time, and, on the kids funnels, the child's
   * age. Applied to the profile once the account exists; the server owns every
   * mapping. NOT inside `properties`: that bag is published on UserCreated and
   * stored whole into another module's `user_plan_assignments.properties`.
   */
  quizAnswers?: InputMaybe<Array<QuizAnswerInput>>;
  urlParams: Scalars['String']['input'];
};

export type SocialProofBlock = {
  __typename?: 'SocialProofBlock';
  /** A string, never a number: both 86% and 80K+ occur. */
  count: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SolidPayPalPaymentIntent = {
  __typename?: 'SolidPayPalPaymentIntent';
  paymentIntentId: Scalars['String']['output'];
  scriptURL: Scalars['String']['output'];
};

export type SolidPayPalPaymentIntentByPrice = {
  __typename?: 'SolidPayPalPaymentIntentByPrice';
  chargedPrice: CheckoutChargedPrice;
  paymentIntentId: Scalars['String']['output'];
  scriptURL: Scalars['String']['output'];
};

export type SolidPaymentIntent = {
  __typename?: 'SolidPaymentIntent';
  merchant: Scalars['String']['output'];
  paymentIntent: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

export type SolidPaymentIntentByPrice = {
  __typename?: 'SolidPaymentIntentByPrice';
  chargedPrice: CheckoutChargedPrice;
  merchant: Scalars['String']['output'];
  paymentIntent: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
  signature: Scalars['String']['output'];
};

/** Which flow the client must start for this plan. Null = no flow (normal home screen). */
export type StartFlow = {
  __typename?: 'StartFlow';
  /**
   * The comeback practice this flow ends in. Present only when `type` is `returnFlow` or
   * `returnFlowDormant`, and the same practice for every user of a plan. Echo `practiceId` back to
   * `completeReturnPractice` so the completion records what was actually rendered.
   */
  returnPractice?: Maybe<ReturnPractice>;
  type: StartFlowType;
};

/**
 * Why a user declined to continue in the return flow. These values match the
 * Amplitude `returnFlowCaseSubmitted.caseOption` vocabulary; storage uses the
 * snake_case form.
 */
export enum StartFlowDeclineReason {
  GoalAchieved = 'goalAchieved',
  NotRightTime = 'notRightTime',
  Other = 'other',
  WontWork = 'wontWork'
}

export enum StartFlowStatus {
  Completed = 'completed',
  Shown = 'shown'
}

export enum StartFlowType {
  Onboarding = 'onboarding',
  ReturnFlow = 'returnFlow',
  ReturnFlowDormant = 'returnFlowDormant'
}

export type StreakDay = {
  __typename?: 'StreakDay';
  date: Scalars['String']['output'];
  dayNumber: Scalars['Int']['output'];
  status: StreakDayStatus;
};

export enum StreakDayStatus {
  Completed = 'COMPLETED',
  Current = 'CURRENT',
  Frozen = 'FROZEN',
  Upcoming = 'UPCOMING'
}

export enum StreakMilestoneType {
  Month = 'MONTH',
  Week = 'WEEK'
}

export type StreakPayload = {
  __typename?: 'StreakPayload';
  availableFreezes: Scalars['Int']['output'];
  currentStreak: Scalars['Int']['output'];
  days: Array<StreakDay>;
  longestStreak: Scalars['Int']['output'];
  milestone?: Maybe<StreakMilestoneType>;
  subtitleKey: Scalars['String']['output'];
  titleKey: Scalars['String']['output'];
  week: Array<StreakWeekDay>;
};

export type StreakWeekDay = {
  __typename?: 'StreakWeekDay';
  date: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  frozen: Scalars['Boolean']['output'];
  inCurrentStreak: Scalars['Boolean']['output'];
  isToday: Scalars['Boolean']['output'];
};

export type SubmitSurveyAnswerInput = {
  questionId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
  /**
   * Answer value, shape depends on question type: option id (String) for
   * SINGLE_SELECT, array of option ids for MULTI_SELECT, free text for TEXT.
   */
  value: Scalars['JSON']['input'];
};

export type SubmitSurveyAnswerPayload = {
  __typename?: 'SubmitSurveyAnswerPayload';
  success: Scalars['Boolean']['output'];
};

export type Survey = {
  __typename?: 'Survey';
  id: Scalars['ID']['output'];
  intro: SurveyIntro;
  questions: Array<SurveyQuestion>;
  title: Scalars['String']['output'];
};

export type SurveyIntro = {
  __typename?: 'SurveyIntro';
  badgeBottom: Scalars['String']['output'];
  badgeTop: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  lightningHint: Scalars['String']['output'];
  pillText: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
};

export type SurveyOption = {
  __typename?: 'SurveyOption';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Stable analytics/reporting key — survives copy edits to the question title. */
  key: Scalars['String']['output'];
  /** Present for SINGLE_SELECT / MULTI_SELECT, absent for TEXT. */
  options?: Maybe<Array<SurveyOption>>;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: SurveyQuestionType;
};

export enum SurveyQuestionType {
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

export type SwapPracticePayload = {
  __typename?: 'SwapPracticePayload';
  practiceId: Scalars['ID']['output'];
  swap: PracticeSwapState;
};

export type TaxInfo = {
  __typename?: 'TaxInfo';
  billingGeo: Scalars['String']['output'];
  taxName: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

/** A single text block inside a DiscoveryItem */
export type Text = {
  __typename?: 'Text';
  number: Scalars['Int']['output'];
  size: TextSize;
  text: Scalars['String']['output'];
};

/** Inputs */
export type TextInput = {
  number: Scalars['Int']['input'];
  size?: TextSize;
  text: Scalars['String']['input'];
};

/** Size options for Text blocks */
export enum TextSize {
  Big = 'BIG',
  Small = 'SMALL',
  Standard = 'STANDARD'
}

export type TodaysFocusContent = {
  __typename?: 'TodaysFocusContent';
  shortText: Scalars['String']['output'];
};

export enum UnitSystem {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export type UpdateKidProfileInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  fitnessLevel?: InputMaybe<Scalars['String']['input']>;
  heightMm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  practiceTime?: InputMaybe<Scalars['String']['input']>;
  soundEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  unitSystem?: InputMaybe<UnitSystem>;
  weightG?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  activePlanId?: Maybe<Scalars['String']['output']>;
  availablePlanIds?: Maybe<Array<Scalars['String']['output']>>;
  availablePlans: Array<AvailablePlan>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use regionalProfileLayout. */
  complianceSensitiveMarket: Scalars['Boolean']['output'];
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** ISO date (YYYY-MM-DD). Null until the user fills it in — Add yours is a designed state. */
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enhancedProfile: Scalars['Boolean']['output'];
  /**
   * Option ids from profileFieldOptions, not enums: a client must render the label
   * for the id the server sends rather than a case it hardcoded, and must skip an
   * id it does not recognise rather than show it raw.
   */
  fitnessLevel?: Maybe<Scalars['String']['output']>;
  /**
   * Canonical and unit-free. unitSystem only decides how these render, so
   * switching units never rewrites the value — centimetres cannot hold 177.8.
   */
  heightMm?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isStoic?: Maybe<Scalars['Boolean']['output']>;
  /** Null when no kid profile exists yet. */
  kidProfile?: Maybe<KidProfile>;
  language?: Maybe<Locale>;
  /** @deprecated Use id instead. learnWorldsId is a legacy field that will be removed. */
  learnWorldsId?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  practiceTime?: Maybe<Scalars['String']['output']>;
  quizAnswers?: Maybe<Array<QuizAnswer>>;
  regionalProfileLayout: Scalars['Boolean']['output'];
  soundEnabled: Scalars['Boolean']['output'];
  streak?: Maybe<StreakPayload>;
  /** Never null: falls back to what countryIsoCode implies. */
  unitSystem: UnitSystem;
  updatedAt: Scalars['DateTime']['output'];
  userReviewPayload?: Maybe<UserReviewPayload>;
  weightG?: Maybe<Scalars['Int']['output']>;
};

export type UserDayProgress = {
  __typename?: 'UserDayProgress';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * True when the user finished at least one Do Extra practice on this day. Every
   * completion recorded for the day counts, so it survives the extras being changed.
   */
  completedDoExtra: Scalars['Boolean']['output'];
  /**
   * The return flow's comeback practice, when the user finished one on this day. The hub
   * names it, so it is the practice and not a flag — and it cannot be borrowed from
   * `startFlow`, which stops carrying it once the impression is burned. Its own record, not
   * a Do Extra: the comeback is credited to the day the user came back on, which is rarely
   * the day its practice belongs to.
   */
  completedReturnPractice?: Maybe<ReturnPractice>;
  completionState: DayCompletionState;
  createdAt: Scalars['DateTime']['output'];
  dayId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastAccessedAt: Scalars['DateTime']['output'];
  /**
   * The return flow's comeback practice, landed on this day when the flow was served and not
   * done yet. It stays until completed — `completeReturnPractice` works from here as well as
   * from the flow — and a later serve keeps it rather than landing a second one, so at most
   * one outstanding comeback exists per plan. Finishing this day the ordinary way drops it.
   * Exclusive with `completedReturnPractice`, and counted nowhere until done.
   */
  offeredReturnPractice?: Maybe<ReturnPractice>;
  openOn?: Maybe<Scalars['DateTime']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type UserGoalProgress = {
  __typename?: 'UserGoalProgress';
  createdAt: Scalars['DateTime']['output'];
  currentDayId?: Maybe<Scalars['ID']['output']>;
  currentSegmentId?: Maybe<Scalars['ID']['output']>;
  exercisesCompleted: Scalars['Int']['output'];
  /** Step-by-step permanent goal: content past the preview wall exists — the client draws the "grow" card. Always false for the classic multi-goal journey. */
  hasMoreLocked: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  lastCompletedDayId?: Maybe<Scalars['ID']['output']>;
  minutesExercised: Scalars['Int']['output'];
  nextGoalId?: Maybe<Scalars['ID']['output']>;
  prevGoalId?: Maybe<Scalars['ID']['output']>;
};

export type UserInput = {
  email: Scalars['String']['input'];
};

export type UserNotice = {
  __typename?: 'UserNotice';
  /**
   * Absolute URL the CTA opens in an in-app browser (the payment-method-change form).
   * Backend-owned so it can change without an app release.
   */
  actionUrl: Scalars['String']['output'];
  /**
   * NONE unless the user still bills through PayPal (no payment-method swap recorded
   * yet). Otherwise decided per subscription from its billing status: a dunning
   * subscription answers HARD, one that is active or not yet charged answers SOFT. A
   * user billing several subscriptions is answered for the worst of them. SOFT is
   * shown only if the user has not been served it today: reading the query consumes
   * that day's SOFT show. HARD is not rationed and does not consume anything — it
   * stays until the method is actually swapped.
   */
  noticeType: UserNoticeType;
};

/**
 * Where the client is about to present the notice. The server answers per surface, so
 * turning one of them off — or keeping the HARD dead-end out of the profile — is a
 * backend decision, not a rule duplicated in three clients.
 */
export enum UserNoticeSurface {
  Launch = 'LAUNCH',
  Profile = 'PROFILE'
}

/**
 * Which notice this user should see, if any. The server owns the decision so the clients
 * stay dumb: SOFT is a dismissible nudge, HARD is a dead-end.
 *
 * Today this is the "update your payment method" screen for PayPal payers. The API
 * vocabulary is deliberately neutral because the operation text ships inside the app
 * binaries; the payments-domain names behind it (PayPalBillingService,
 * payment_prompt_shown, the SOFT/HARD switch) stay explicit — server code is not shipped.
 */
export enum UserNoticeType {
  Hard = 'HARD',
  None = 'NONE',
  Soft = 'SOFT'
}

export type UserPlanProgress = {
  __typename?: 'UserPlanProgress';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentDayId?: Maybe<Scalars['ID']['output']>;
  currentGoalId?: Maybe<Scalars['ID']['output']>;
  currentSegmentId?: Maybe<Scalars['ID']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastAccessedAt: Scalars['DateTime']['output'];
  openOn: Scalars['DateTime']['output'];
  planId: Scalars['ID']['output'];
  purchasedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type UserResponse = {
  __typename?: 'UserResponse';
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use id instead. learnWorldsId is a legacy field that will be removed. */
  learnWorldsId: Scalars['String']['output'];
};

export type UserReviewPayload = {
  __typename?: 'UserReviewPayload';
  data: ReviewTracking;
  link?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type UserSegmentProgress = {
  __typename?: 'UserSegmentProgress';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  days: Array<Day>;
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  lastAccessedAt: Scalars['DateTime']['output'];
  locale: Scalars['String']['output'];
  milestone?: Maybe<Milestone>;
  openOn: Scalars['DateTime']['output'];
  segment?: Maybe<Segment>;
  segmentId: Scalars['ID']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export enum VideoFormat {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type VideoMetadata = {
  __typename?: 'VideoMetadata';
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<VideoFormat>;
  pose?: Maybe<Scalars['String']['output']>;
};

export type WebAutoLoginInput = {
  locale: Locale;
  /**
   * Accepts either a current user.id or a legacy learnWorldsId.
   * Backend resolves both via fallback lookup. The legacy path exists
   * because old email/funnel links still contain learnWorldsId values
   * and must keep working indefinitely.
   */
  userIdOrLegacyId: Scalars['String']['input'];
};

export type WebAutoLoginResponse = {
  __typename?: 'WebAutoLoginResponse';
  redirectURL: Scalars['String']['output'];
};

export type WheelFrame = {
  __typename?: 'WheelFrame';
  inner: Scalars['String']['output'];
  outer: Scalars['String']['output'];
};

/** One play of a wheel game. Every round is decided before the first spin; the wheel only lands on it. */
export type WheelGame = {
  __typename?: 'WheelGame';
  /** The library exercise: the id CardGame.exerciseId serves too. */
  exerciseId: Scalars['ID']['output'];
  /** The lines framing a round, as in 'The floor is ___ / You are ___'. Null when the game has none. */
  frame?: Maybe<WheelFrame>;
  howToPlay: Array<WheelHowToPlayStep>;
  /** The inner ring, in authored order. */
  innerRing: Array<WheelItem>;
  /** The outer ring, in authored order. */
  outerRing: Array<WheelWay>;
  /** In play order, one per item. */
  rounds: Array<WheelRound>;
  /** How many slices of the outer ring each way takes: the ways repeat around it in order. */
  slicesPerWay: Scalars['Int']['output'];
  tip?: Maybe<Scalars['String']['output']>;
};

export type WheelHowToPlayStep = {
  __typename?: 'WheelHowToPlayStep';
  text: Scalars['String']['output'];
};

export type WheelItem = {
  __typename?: 'WheelItem';
  code: Scalars['ID']['output'];
  /** The same in every age of the game. Null until authored. */
  color?: Maybe<CardPaletteColor>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  /** Played when the wheel lands on this item. */
  soundUrl?: Maybe<Scalars['String']['output']>;
};

export type WheelRound = {
  __typename?: 'WheelRound';
  /** The pair's short instructions, else the way's default line. Null when neither is authored. */
  hint?: Maybe<Scalars['String']['output']>;
  itemCode: Scalars['ID']['output'];
  /** The English title wherever a translation breaks its tags. */
  title: WheelText;
  wayCode: Scalars['ID']['output'];
};

/** A sentence in segments, so the client styles each by its role and never parses tags. */
export type WheelText = {
  __typename?: 'WheelText';
  /** The sentence without tags. */
  plain: Scalars['String']['output'];
  segments: Array<WheelTextSegment>;
};

/** Which part of the round a segment names: the item reveals as the inner ring stops, the way as the outer one does. */
export enum WheelTextRole {
  Item = 'ITEM',
  Way = 'WAY'
}

export type WheelTextSegment = {
  __typename?: 'WheelTextSegment';
  /** Null for plain text. */
  role?: Maybe<WheelTextRole>;
  text: Scalars['String']['output'];
};

export type WheelWay = {
  __typename?: 'WheelWay';
  code: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type MarkExperimentExposedMutationVariables = Exact<{
  experimentName: Scalars['String']['input'];
  planId?: InputMaybe<Scalars['String']['input']>;
  arm?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarkExperimentExposedMutation = { __typename?: 'Mutation', markExperimentExposed: boolean };

export type CompleteOnboardingMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type CompleteOnboardingMutation = { __typename?: 'Mutation', completeOnboarding: boolean };

export type OnboardingsToShowQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingsToShowQuery = { __typename?: 'Query', onboardingsToShow: Array<string> };

export type PlayerSoundSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerSoundSettingQuery = { __typename?: 'Query', me: { __typename?: 'User', soundEnabled: boolean } };

export type CollectionPendingChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionPendingChangesQuery = { __typename?: 'Query', myCollection: { __typename?: 'Collection', hasPendingChanges: boolean } };

export type CollectionEarnedCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionEarnedCardsQuery = { __typename?: 'Query', myCollection: { __typename?: 'Collection', pendingChanges: Array<{ __typename?: 'MasteryChange', exerciseId: string, thumbnailUrl?: string | null, case: MasteryChangeCase }> } };

export type DiscoveryItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoveryItemsQuery = { __typename?: 'Query', discoveryItems?: { __typename?: 'DiscoveryItemsResponse', items: Array<{ __typename?: 'DiscoveryItem', id: string, code?: DiscoveryItemCode | null, description?: string | null, imageUrl: string, url: string, content: Array<{ __typename?: 'Text', number: number, text: string, size: TextSize }> }>, featured: Array<{ __typename?: 'DiscoveryItem', id: string, code?: DiscoveryItemCode | null, description?: string | null, imageUrl: string, url: string, content: Array<{ __typename?: 'Text', number: number, text: string, size: TextSize }> }> } | null };

export type FeatureOnboardingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureOnboardingsQuery = { __typename?: 'Query', featureOnboardings: Array<{ __typename?: 'FeatureOnboarding', key: string, layout: FeatureOnboardingLayout, eyebrow?: string | null, title?: string | null, body?: string | null, contentSource?: FeatureOnboardingContentSource | null, contentLimit: number, triedOptions: Array<{ __typename?: 'FeatureOnboardingOption', id: string, title: string }>, options: Array<{ __typename?: 'FeatureOnboardingOption', id: string, title: string }>, planDays: Array<{ __typename?: 'FeatureOnboardingPlanDay', number: number, title: string, imageUrl?: string | null, practiceTitle?: string | null, practiceDescription?: string | null }> }> };

export type JourneyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type JourneyUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, activePlanId?: string | null, availablePlans: Array<{ __typename?: 'AvailablePlan', id: string, title: string, code: string, contentFormat: ContentFormat, dayFormat: DayFormat, currentGoalId?: string | null }> } };

export type MyGoalQueryVariables = Exact<{
  goalId: Scalars['ID']['input'];
}>;


export type MyGoalQuery = { __typename?: 'Query', myGoal?: { __typename?: 'Goal', id: string, number: number, title: string, description?: string | null, goalTakeaways?: Array<{ __typename?: 'GoalTakeaway', upcomingTitle: string, doneTitle: string }> | null, milestone?: { __typename?: 'Milestone', id: string, title: string, description?: string | null, milestoneType: MilestoneType, celebrationTitle?: string | null, celebrationBody?: string | null, milestoneResult?: string | null, nextUp?: { __typename?: 'MilestoneNextUp', title: string, message: string } | null } | null, segments: Array<{ __typename?: 'SegmentWithProgress', id: string, number: number, title: string, description?: string | null, milestone?: { __typename?: 'Milestone', id: string, title: string, description?: string | null, milestoneType: MilestoneType, celebrationTitle?: string | null, celebrationBody?: string | null, milestoneResult?: string | null, nextUp?: { __typename?: 'MilestoneNextUp', title: string, message: string } | null } | null, userProgress?: { __typename?: 'UserSegmentProgress', isCompleted: boolean } | null, days: Array<{ __typename?: 'DayWithProgress', id: string, number: number, title: string, imageUrl?: string | null, practiceCount: number, userProgress?: { __typename?: 'UserDayProgress', isCompleted: boolean, openOn?: string | null, completedAt?: string | null, completionState: DayCompletionState, completedDoExtra: boolean } | null }> }>, userProgress?: { __typename?: 'UserGoalProgress', isOpen: boolean, isCompleted: boolean, currentSegmentId?: string | null, currentDayId?: string | null, lastCompletedDayId?: string | null, nextGoalId?: string | null, prevGoalId?: string | null, minutesExercised: number, exercisesCompleted: number, hasMoreLocked: boolean } | null } | null };

export type CompleteDayMutationVariables = Exact<{
  dayId: Scalars['ID']['input'];
}>;


export type CompleteDayMutation = { __typename?: 'Mutation', completeDay: { __typename?: 'CompleteDayResponse', userProgress: { __typename?: 'UserDayProgress', isCompleted: boolean }, streakPayload?: { __typename?: 'StreakPayload', currentStreak: number, titleKey: string, subtitleKey: string, days: Array<{ __typename?: 'StreakDay', date: string, dayNumber: number, status: StreakDayStatus }> } | null, userReviewPayload?: { __typename?: 'UserReviewPayload', type: string, link?: string | null } | null, pendingSurvey?: { __typename?: 'Survey', id: string, title: string, intro: { __typename?: 'SurveyIntro', badgeTop: string, badgeBottom: string, lightningHint: string, heading: string, subheading: string }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, key: string, type: SurveyQuestionType, title: string, description?: string | null, required: boolean, options?: Array<{ __typename?: 'SurveyOption', id: string, title: string }> | null }> } | null } };

export type CompletePracticeMutationVariables = Exact<{
  practiceId: Scalars['ID']['input'];
  dayId: Scalars['ID']['input'];
}>;


export type CompletePracticeMutation = { __typename?: 'Mutation', completePractice: { __typename?: 'CompletePracticePayload', collectFeedback: boolean, streakPayload?: { __typename?: 'StreakPayload', currentStreak: number, titleKey: string, subtitleKey: string, days: Array<{ __typename?: 'StreakDay', date: string, dayNumber: number, status: StreakDayStatus }> } | null, photoPrompt?: { __typename?: 'PhotoPrompt', variant: PhotoPromptVariant } | null, userReviewPayload?: { __typename?: 'UserReviewPayload', type: string, link?: string | null } | null, pendingSurvey?: { __typename?: 'Survey', id: string, title: string, intro: { __typename?: 'SurveyIntro', badgeTop: string, badgeBottom: string, lightningHint: string, heading: string, subheading: string }, questions: Array<{ __typename?: 'SurveyQuestion', id: string, key: string, type: SurveyQuestionType, title: string, description?: string | null, required: boolean, options?: Array<{ __typename?: 'SurveyOption', id: string, title: string }> | null }> } | null } };

export type DayQueryVariables = Exact<{
  dayId: Scalars['ID']['input'];
}>;


export type DayQuery = { __typename?: 'Query', myDay?: { __typename?: 'DayWithProgress', id: string, title: string, imageUrl?: string | null, number: number, segmentId: string, photoMemory?: { __typename?: 'PhotoMemory', id: string, thumbnailUrl: string } | null, blocks: Array<{ __typename?: 'DayBlock', id: string, author?: string | null, type: BlockType, title?: string | null, text?: string | null, url?: string | null, caption?: string | null, thumbnailUrl?: string | null, number: number, points?: Array<{ __typename?: 'Point', title: string, text?: string | null }> | null, videoMetadata?: { __typename?: 'VideoMetadata', format?: VideoFormat | null, durationMinutes?: number | null, pose?: string | null } | null, content?:
        | { __typename: 'DayOutroContent', shortText: string }
        | { __typename: 'DoExtraContent', practices: Array<{ __typename?: 'DoExtraPractice', sourceId: string, title: string, description?: string | null, whyItWorks?: string | null, outroLine?: string | null, thumbnailUrl?: string | null, durationMinutes: number, equipment: Array<string>, isCompleted: boolean, voicePrefixes?: { __typename?: 'PracticeVoicePrefixes', firstUrl: string, nextUrl: string, lastUrl: string } | null, exercises: Array<{ __typename?: 'DoExtraExercise', format: ExerciseFormat, title?: string | null, text?: string | null, url?: string | null, thumbnailUrl?: string | null, durationMinutes?: number | null, nameAudioUrl?: string | null, game?: { __typename: 'WheelGame', exerciseId: string, tip?: string | null, slicesPerWay: number, howToPlay: Array<{ __typename?: 'WheelHowToPlayStep', text: string }>, innerRing: Array<{ __typename?: 'WheelItem', code: string, label: string, color?: CardPaletteColor | null, imageUrl?: string | null, soundUrl?: string | null }>, outerRing: Array<{ __typename?: 'WheelWay', code: string, label: string }>, rounds: Array<{ __typename?: 'WheelRound', itemCode: string, wayCode: string, hint?: string | null, title: { __typename?: 'WheelText', plain: string, segments: Array<{ __typename?: 'WheelTextSegment', text: string, role?: WheelTextRole | null }> } }> } | null, cardGame?: { __typename?: 'CardGame', exerciseId: string, dealId: string, tip?: string | null, howToPlay?: Array<{ __typename?: 'CardGameHowToPlayStep', title?: string | null, text: string }> | null, rounds: Array<{ __typename?: 'CardGameRound', key: string, rule?: { __typename?: 'CardGameCard', id: string, imageUrl?: string | null, front: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }>, back: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }> } | null, cards: Array<{ __typename?: 'CardGameCard', id: string, imageUrl?: string | null, front: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }>, back: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }> }> }> } | null }> }> }
        | { __typename: 'EducationalIntroContent', educationalTitle: string, blocks: Array<{ __typename?: 'EducationalBlock', id: string, type: BlockType, title?: string | null, text?: string | null, url?: string | null, thumbnailUrl?: string | null }> }
        | { __typename: 'IntroContent', shortText: string }
        | { __typename: 'PracticeContent', title: string, description?: string | null, whyItWorks?: string | null, outroLine?: string | null, durationMinutes: number, equipment: Array<string>, voicePrefixes?: { __typename?: 'PracticeVoicePrefixes', firstUrl: string, nextUrl: string, lastUrl: string } | null, tags: Array<{ __typename?: 'PracticeTag', id: string, code: string, title: string }>, exercises: Array<{ __typename?: 'PracticeExercise', id: string, format: ExerciseFormat, title?: string | null, text?: string | null, url?: string | null, thumbnailUrl?: string | null, durationMinutes?: number | null, equipment: Array<string>, nameAudioUrl?: string | null, game?: { __typename: 'WheelGame', exerciseId: string, tip?: string | null, slicesPerWay: number, howToPlay: Array<{ __typename?: 'WheelHowToPlayStep', text: string }>, innerRing: Array<{ __typename?: 'WheelItem', code: string, label: string, color?: CardPaletteColor | null, imageUrl?: string | null, soundUrl?: string | null }>, outerRing: Array<{ __typename?: 'WheelWay', code: string, label: string }>, rounds: Array<{ __typename?: 'WheelRound', itemCode: string, wayCode: string, hint?: string | null, title: { __typename?: 'WheelText', plain: string, segments: Array<{ __typename?: 'WheelTextSegment', text: string, role?: WheelTextRole | null }> } }> } | null, cardGame?: { __typename?: 'CardGame', exerciseId: string, dealId: string, tip?: string | null, howToPlay?: Array<{ __typename?: 'CardGameHowToPlayStep', title?: string | null, text: string }> | null, rounds: Array<{ __typename?: 'CardGameRound', key: string, rule?: { __typename?: 'CardGameCard', id: string, imageUrl?: string | null, front: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }>, back: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }> } | null, cards: Array<{ __typename?: 'CardGameCard', id: string, imageUrl?: string | null, front: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }>, back: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }> }> }> } | null }>, completion: { __typename?: 'PracticeCompletion', isCompleted: boolean, completedAt?: string | null } }
        | { __typename: 'TodaysFocusContent', shortText: string }
       | null }>, userProgress?: { __typename?: 'UserDayProgress', isCompleted: boolean, openOn?: string | null, completionState: DayCompletionState, completedReturnPractice?: { __typename?: 'ReturnPractice', practiceId: string, title: string, description?: string | null, whyItWorks?: string | null, outroLine?: string | null, thumbnailUrl?: string | null, durationMinutes: number, equipment: Array<string>, exercises: Array<{ __typename?: 'PracticeExercise', id: string, format: ExerciseFormat, title?: string | null, text?: string | null, url?: string | null, thumbnailUrl?: string | null, durationMinutes?: number | null, equipment: Array<string>, game?: { __typename: 'WheelGame', exerciseId: string, tip?: string | null, slicesPerWay: number, howToPlay: Array<{ __typename?: 'WheelHowToPlayStep', text: string }>, innerRing: Array<{ __typename?: 'WheelItem', code: string, label: string, color?: CardPaletteColor | null, imageUrl?: string | null, soundUrl?: string | null }>, outerRing: Array<{ __typename?: 'WheelWay', code: string, label: string }>, rounds: Array<{ __typename?: 'WheelRound', itemCode: string, wayCode: string, hint?: string | null, title: { __typename?: 'WheelText', plain: string, segments: Array<{ __typename?: 'WheelTextSegment', text: string, role?: WheelTextRole | null }> } }> } | null }> } | null } | null } | null };

export type DetailedSegmentQueryVariables = Exact<{
  segmentId: Scalars['ID']['input'];
}>;


export type DetailedSegmentQuery = { __typename?: 'Query', mySegment?: { __typename?: 'SegmentWithProgress', id: string, title: string, number: number, days: Array<{ __typename?: 'DayWithProgress', id: string, number: number, title: string, imageUrl?: string | null, userProgress?: { __typename?: 'UserDayProgress', isCompleted: boolean, openOn?: string | null } | null }>, userProgress?: { __typename?: 'UserSegmentProgress', isCompleted: boolean, openOn: string } | null } | null };

export type MarkDoExtraCompletedMutationVariables = Exact<{
  dayId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
}>;


export type MarkDoExtraCompletedMutation = { __typename?: 'Mutation', markDoExtraCompleted: boolean };

export type MyPlanQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type MyPlanQuery = { __typename?: 'Query', myPlan?: { __typename?: 'PlanWithProgress', id: string, title: string, description?: string | null, segments: Array<{ __typename?: 'SegmentWithProgress', id: string, number: number, title: string, userProgress?: { __typename?: 'UserSegmentProgress', isCompleted: boolean, openOn: string } | null }> } | null };

export type PlanUserProgressQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type PlanUserProgressQuery = { __typename?: 'Query', myPlan?: { __typename?: 'PlanWithProgress', id: string, userProgress?: { __typename?: 'UserPlanProgress', isCompleted: boolean, currentSegmentId?: string | null, currentDayId?: string | null } | null } | null };

export type RateDayMutationVariables = Exact<{
  dayId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
}>;


export type RateDayMutation = { __typename?: 'Mutation', rateDay: { __typename?: 'CompleteDayResponse', userProgress: { __typename?: 'UserDayProgress', rating?: number | null } } };

export type RatePracticeMutationVariables = Exact<{
  practiceId: Scalars['ID']['input'];
  dayId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
}>;


export type RatePracticeMutation = { __typename?: 'Mutation', ratePractice: { __typename?: 'RatePracticePayload', success: boolean } };

export type ReviewAcceptedMutationVariables = Exact<{
  reviewType: ReviewType;
}>;


export type ReviewAcceptedMutation = { __typename?: 'Mutation', reviewAccepted: boolean };

export type SetActivePlanMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type SetActivePlanMutation = { __typename?: 'Mutation', setActivePlan: string };

export type UserProgressDataQueryVariables = Exact<{
  planId: Scalars['ID']['input'];
}>;


export type UserProgressDataQuery = { __typename?: 'Query', myPlan?: { __typename?: 'PlanWithProgress', segments: Array<{ __typename?: 'SegmentWithProgress', days: Array<{ __typename?: 'DayWithProgress', userProgress?: { __typename?: 'UserDayProgress', isCompleted: boolean } | null }> }> } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name?: string | null, email: string, language?: Locale | null, isStoic?: boolean | null, activePlanId?: string | null, enhancedProfile: boolean, streak?: { __typename?: 'StreakPayload', currentStreak: number, longestStreak: number, availableFreezes: number, titleKey: string, subtitleKey: string, milestone?: StreakMilestoneType | null, days: Array<{ __typename?: 'StreakDay', date: string, status: StreakDayStatus, dayNumber: number }> } | null, availablePlans: Array<{ __typename?: 'AvailablePlan', id: string, title: string, code: string, contentFormat: ContentFormat, dayFormat: DayFormat, currentGoalId?: string | null, availableLanguages: Array<string>, hasCollection: boolean, hasNewPracticePlayer: boolean, stepByStep: boolean, hasPhotoMemories: boolean, photoMemoryCount: number, firstRecapPhotoMemoryCount: number, onboarding?: { __typename?: 'PlanOnboarding', id: string, analyticsPlanType: string, ctaLabel: string, steps: Array<{ __typename?: 'PlanOnboardingStep', id: string, showsProgress: boolean, title?: string | null, subtitle?: string | null, blocks: Array<
            | { __typename: 'FactListBlock', id: string, facts: Array<{ __typename?: 'OnboardingFact', id: string, text: string, icon: { __typename?: 'AssetRef', name?: string | null, url: string } }> }
            | { __typename: 'GoalBadgeBlock', id: string, goalTitle: string }
            | { __typename: 'PracticeCardBlock', id: string, completed: { __typename?: 'DayPractice', title: string, durationMinutes: number, thumbnailUrl?: string | null }, next: { __typename?: 'DayPractice', title: string, durationMinutes: number, thumbnailUrl?: string | null } }
            | { __typename: 'PracticeChainBlock', id: string, days: Array<{ __typename?: 'ChainDay', number: number, practiceCount: number, thumbnailUrl?: string | null }> }
            | { __typename: 'PracticeCurveBlock', id: string, goalCallout: string, callouts: { __typename?: 'CurveCallouts', start: string, mid: string, end: string } }
            | { __typename: 'PreparingBlock', id: string, durationLabel: string, durationMinutes?: number | null, ctaHint: string }
            | { __typename: 'SocialProofBlock', id: string, count: string, text: string }
          > }> } | null, startFlow?: { __typename?: 'StartFlow', type: StartFlowType, returnPractice?: { __typename?: 'ReturnPractice', practiceId: string, title: string, description?: string | null, whyItWorks?: string | null, outroLine?: string | null, thumbnailUrl?: string | null, durationMinutes: number, equipment: Array<string>, voicePrefixes?: { __typename?: 'PracticeVoicePrefixes', firstUrl: string, nextUrl: string, lastUrl: string } | null, exercises: Array<{ __typename?: 'PracticeExercise', id: string, format: ExerciseFormat, title?: string | null, text?: string | null, url?: string | null, thumbnailUrl?: string | null, durationMinutes?: number | null, equipment: Array<string>, nameAudioUrl?: string | null, cardGame?: { __typename?: 'CardGame', exerciseId: string, dealId: string, tip?: string | null, howToPlay?: Array<{ __typename?: 'CardGameHowToPlayStep', title?: string | null, text: string }> | null, rounds: Array<{ __typename?: 'CardGameRound', key: string, rule?: { __typename?: 'CardGameCard', id: string, imageUrl?: string | null, front: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }>, back: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }> } | null, cards: Array<{ __typename?: 'CardGameCard', id: string, imageUrl?: string | null, front: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }>, back: Array<{ __typename?: 'CardGameBlock', kind: string, title?: string | null, text?: string | null, items: Array<{ __typename?: 'CardGameBlockItem', imageUrl: string, text: string }> }> }> }> } | null, game?: { __typename: 'WheelGame', exerciseId: string, tip?: string | null, slicesPerWay: number, howToPlay: Array<{ __typename?: 'WheelHowToPlayStep', text: string }>, innerRing: Array<{ __typename?: 'WheelItem', code: string, label: string, color?: CardPaletteColor | null, imageUrl?: string | null, soundUrl?: string | null }>, outerRing: Array<{ __typename?: 'WheelWay', code: string, label: string }>, rounds: Array<{ __typename?: 'WheelRound', itemCode: string, wayCode: string, hint?: string | null, title: { __typename?: 'WheelText', plain: string, segments: Array<{ __typename?: 'WheelTextSegment', text: string, role?: WheelTextRole | null }> } }> } | null }> } | null } | null }> } };

export type CollectionHighlightsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectionHighlightsQuery = { __typename?: 'Query', myCollection: { __typename?: 'Collection', cards: Array<{ __typename?: 'CollectionCard', exerciseId: string, title: string, thumbnailUrl?: string | null, tier: number }>, summary: { __typename?: 'CollectionSummary', collected: number, total: number } } };

export type SetLanguageMutationVariables = Exact<{
  language: Locale;
}>;


export type SetLanguageMutation = { __typename?: 'Mutation', setLanguage: boolean };

export type UserProfileDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileDetailsQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, avatarUrl?: string | null, regionalProfileLayout: boolean, dateOfBirth?: string | null, heightMm?: number | null, weightG?: number | null, fitnessLevel?: string | null, practiceTime?: string | null, unitSystem: UnitSystem, kidProfile?: { __typename?: 'KidProfile', name?: string | null, dateOfBirth?: string | null } | null, streak?: { __typename?: 'StreakPayload', week: Array<{ __typename?: 'StreakWeekDay', date: string, frozen: boolean, inCurrentStreak: boolean }> } | null } };

export type CompleteReturnPracticeMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  practiceId: Scalars['ID']['input'];
}>;


export type CompleteReturnPracticeMutation = { __typename?: 'Mutation', completeReturnPractice: { __typename?: 'CompleteReturnPracticePayload', dayId: string, streakPayload?: { __typename?: 'StreakPayload', currentStreak: number, titleKey: string, subtitleKey: string, days: Array<{ __typename?: 'StreakDay', date: string, dayNumber: number, status: StreakDayStatus }> } | null } };

export type SetStartFlowDeclineFeedbackMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  flowType: StartFlowType;
  reason: StartFlowDeclineReason;
  freeformText?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetStartFlowDeclineFeedbackMutation = { __typename?: 'Mutation', setStartFlowDeclineFeedback: boolean };

export type SetStartFlowStatusMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  flowType: StartFlowType;
  status: StartFlowStatus;
}>;


export type SetStartFlowStatusMutation = { __typename?: 'Mutation', setStartFlowStatus: boolean };

export type ProfileFieldOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileFieldOptionsQuery = { __typename?: 'Query', profileFieldOptions: { __typename?: 'ProfileFieldOptions', fitnessLevel: Array<{ __typename?: 'ProfileFieldOption', id: string }>, practiceTime: Array<{ __typename?: 'ProfileFieldOption', id: string }> } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'User', id: string, dateOfBirth?: string | null, heightMm?: number | null, weightG?: number | null, fitnessLevel?: string | null, practiceTime?: string | null, unitSystem: UnitSystem, name?: string | null } };

export type UpdateKidProfileMutationVariables = Exact<{
  input: UpdateKidProfileInput;
}>;


export type UpdateKidProfileMutation = { __typename?: 'Mutation', updateKidProfile: { __typename?: 'User', id: string, kidProfile?: { __typename?: 'KidProfile', name?: string | null, dateOfBirth?: string | null } | null } };

export type SubmitSurveyAnswerMutationVariables = Exact<{
  input: SubmitSurveyAnswerInput;
}>;


export type SubmitSurveyAnswerMutation = { __typename?: 'Mutation', submitSurveyAnswer: { __typename?: 'SubmitSurveyAnswerPayload', success: boolean } };

export type UserNoticeQueryVariables = Exact<{
  surface: UserNoticeSurface;
}>;


export type UserNoticeQuery = { __typename?: 'Query', userNotice: { __typename?: 'UserNotice', noticeType: UserNoticeType, actionUrl: string } };

export type UserNoticeDeadEndQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNoticeDeadEndQuery = { __typename?: 'Query', userNotice: { __typename?: 'UserNotice', noticeType: UserNoticeType, actionUrl: string } };


export const MarkExperimentExposedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkExperimentExposed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"experimentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"arm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markExperimentExposed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"experimentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"experimentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"Argument","name":{"kind":"Name","value":"arm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"arm"}}}]}]}}]} as unknown as DocumentNode<MarkExperimentExposedMutation, MarkExperimentExposedMutationVariables>;
export const CompleteOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}]}}]} as unknown as DocumentNode<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export const OnboardingsToShowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingsToShow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboardingsToShow"}}]}}]} as unknown as DocumentNode<OnboardingsToShowQuery, OnboardingsToShowQueryVariables>;
export const PlayerSoundSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlayerSoundSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"soundEnabled"}}]}}]}}]} as unknown as DocumentNode<PlayerSoundSettingQuery, PlayerSoundSettingQueryVariables>;
export const CollectionPendingChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionPendingChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPendingChanges"}}]}}]}}]} as unknown as DocumentNode<CollectionPendingChangesQuery, CollectionPendingChangesQueryVariables>;
export const CollectionEarnedCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionEarnedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"case"}}]}}]}}]}}]} as unknown as DocumentNode<CollectionEarnedCardsQuery, CollectionEarnedCardsQueryVariables>;
export const DiscoveryItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DiscoveryItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discoveryItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DiscoveryItemsQuery, DiscoveryItemsQueryVariables>;
export const FeatureOnboardingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeatureOnboardings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureOnboardings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"eyebrow"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"triedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contentSource"}},{"kind":"Field","name":{"kind":"Name","value":"contentLimit"}},{"kind":"Field","name":{"kind":"Name","value":"planDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"practiceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"practiceDescription"}}]}}]}}]}}]} as unknown as DocumentNode<FeatureOnboardingsQuery, FeatureOnboardingsQueryVariables>;
export const JourneyUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JourneyUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activePlanId"}},{"kind":"Field","name":{"kind":"Name","value":"availablePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"contentFormat"}},{"kind":"Field","name":{"kind":"Name","value":"dayFormat"}},{"kind":"Field","name":{"kind":"Name","value":"currentGoalId"}}]}}]}}]}}]} as unknown as DocumentNode<JourneyUserQuery, JourneyUserQueryVariables>;
export const MyGoalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyGoal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myGoal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"goalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"goalTakeaways"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"doneTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneType"}},{"kind":"Field","name":{"kind":"Name","value":"celebrationTitle"}},{"kind":"Field","name":{"kind":"Name","value":"celebrationBody"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneResult"}},{"kind":"Field","name":{"kind":"Name","value":"nextUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"milestone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneType"}},{"kind":"Field","name":{"kind":"Name","value":"celebrationTitle"}},{"kind":"Field","name":{"kind":"Name","value":"celebrationBody"}},{"kind":"Field","name":{"kind":"Name","value":"milestoneResult"}},{"kind":"Field","name":{"kind":"Name","value":"nextUp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"practiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"openOn"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completionState"}},{"kind":"Field","name":{"kind":"Name","value":"completedDoExtra"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOpen"}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"currentSegmentId"}},{"kind":"Field","name":{"kind":"Name","value":"currentDayId"}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletedDayId"}},{"kind":"Field","name":{"kind":"Name","value":"nextGoalId"}},{"kind":"Field","name":{"kind":"Name","value":"prevGoalId"}},{"kind":"Field","name":{"kind":"Name","value":"minutesExercised"}},{"kind":"Field","name":{"kind":"Name","value":"exercisesCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"hasMoreLocked"}}]}}]}}]}}]} as unknown as DocumentNode<MyGoalQuery, MyGoalQueryVariables>;
export const CompleteDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streakPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleKey"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReviewPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"intro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badgeTop"}},{"kind":"Field","name":{"kind":"Name","value":"badgeBottom"}},{"kind":"Field","name":{"kind":"Name","value":"lightningHint"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"subheading"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompleteDayMutation, CompleteDayMutationVariables>;
export const CompletePracticeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompletePractice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"practiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completePractice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"practiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"practiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streakPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleKey"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"photoPrompt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userReviewPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingSurvey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"intro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badgeTop"}},{"kind":"Field","name":{"kind":"Name","value":"badgeBottom"}},{"kind":"Field","name":{"kind":"Name","value":"lightningHint"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"subheading"}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompletePracticeMutation, CompletePracticeMutationVariables>;
export const DayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Day"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"segmentId"}},{"kind":"Field","name":{"kind":"Name","value":"photoMemory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"points"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"pose"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IntroContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodaysFocusContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DayOutroContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortText"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EducationalIntroContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"educationalTitle"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"whyItWorks"}},{"kind":"Field","name":{"kind":"Name","value":"outroLine"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"voicePrefixes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nextUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exercises"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"nameAudioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WheelGame"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"slicesPerWay"}},{"kind":"Field","name":{"kind":"Name","value":"innerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"soundUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemCode"}},{"kind":"Field","name":{"kind":"Name","value":"wayCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plain"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardGame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"dealId"}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"front"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"back"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"front"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"back"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"completion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DoExtraContent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"whyItWorks"}},{"kind":"Field","name":{"kind":"Name","value":"outroLine"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"voicePrefixes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nextUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"exercises"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"nameAudioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WheelGame"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"slicesPerWay"}},{"kind":"Field","name":{"kind":"Name","value":"innerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"soundUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemCode"}},{"kind":"Field","name":{"kind":"Name","value":"wayCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plain"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardGame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"dealId"}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"front"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"back"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"front"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"back"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"openOn"}},{"kind":"Field","name":{"kind":"Name","value":"completionState"}},{"kind":"Field","name":{"kind":"Name","value":"completedReturnPractice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practiceId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"whyItWorks"}},{"kind":"Field","name":{"kind":"Name","value":"outroLine"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"exercises"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WheelGame"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"slicesPerWay"}},{"kind":"Field","name":{"kind":"Name","value":"innerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"soundUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemCode"}},{"kind":"Field","name":{"kind":"Name","value":"wayCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plain"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DayQuery, DayQueryVariables>;
export const DetailedSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DetailedSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mySegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"segmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"openOn"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"openOn"}}]}}]}}]}}]} as unknown as DocumentNode<DetailedSegmentQuery, DetailedSegmentQueryVariables>;
export const MarkDoExtraCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkDoExtraCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markDoExtraCompleted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceId"}}}]}]}}]} as unknown as DocumentNode<MarkDoExtraCompletedMutation, MarkDoExtraCompletedMutationVariables>;
export const MyPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"openOn"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyPlanQuery, MyPlanQueryVariables>;
export const PlanUserProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlanUserProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"currentSegmentId"}},{"kind":"Field","name":{"kind":"Name","value":"currentDayId"}}]}}]}}]}}]} as unknown as DocumentNode<PlanUserProgressQuery, PlanUserProgressQueryVariables>;
export const RateDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RateDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rateDay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]} as unknown as DocumentNode<RateDayMutation, RateDayMutationVariables>;
export const RatePracticeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RatePractice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"practiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rating"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ratePractice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"practiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"practiceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dayId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dayId"}}},{"kind":"Argument","name":{"kind":"Name","value":"rating"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rating"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RatePracticeMutation, RatePracticeMutationVariables>;
export const ReviewAcceptedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewAccepted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReviewType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewAccepted"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reviewType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewType"}}}]}]}}]} as unknown as DocumentNode<ReviewAcceptedMutation, ReviewAcceptedMutationVariables>;
export const SetActivePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetActivePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setActivePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}]}]}}]} as unknown as DocumentNode<SetActivePlanMutation, SetActivePlanMutationVariables>;
export const UserProgressDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProgressData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isCompleted"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProgressDataQuery, UserProgressDataQueryVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"isStoic"}},{"kind":"Field","name":{"kind":"Name","value":"activePlanId"}},{"kind":"Field","name":{"kind":"Name","value":"enhancedProfile"}},{"kind":"Field","name":{"kind":"Name","value":"streak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"}},{"kind":"Field","name":{"kind":"Name","value":"longestStreak"}},{"kind":"Field","name":{"kind":"Name","value":"availableFreezes"}},{"kind":"Field","name":{"kind":"Name","value":"titleKey"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleKey"}},{"kind":"Field","name":{"kind":"Name","value":"milestone"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"dayNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"contentFormat"}},{"kind":"Field","name":{"kind":"Name","value":"dayFormat"}},{"kind":"Field","name":{"kind":"Name","value":"currentGoalId"}},{"kind":"Field","name":{"kind":"Name","value":"availableLanguages"}},{"kind":"Field","name":{"kind":"Name","value":"hasCollection"}},{"kind":"Field","name":{"kind":"Name","value":"hasNewPracticePlayer"}},{"kind":"Field","name":{"kind":"Name","value":"stepByStep"}},{"kind":"Field","name":{"kind":"Name","value":"hasPhotoMemories"}},{"kind":"Field","name":{"kind":"Name","value":"photoMemoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstRecapPhotoMemoryCount"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"analyticsPlanType"}},{"kind":"Field","name":{"kind":"Name","value":"ctaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showsProgress"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FactListBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SocialProofBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeCurveBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"callouts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"mid"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"goalCallout"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreparingBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"durationLabel"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"ctaHint"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoalBadgeBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"goalTitle"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeChainBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"practiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PracticeCardBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"next"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startFlow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"returnPractice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"practiceId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"whyItWorks"}},{"kind":"Field","name":{"kind":"Name","value":"outroLine"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"voicePrefixes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nextUrl"}},{"kind":"Field","name":{"kind":"Name","value":"lastUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exercises"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"equipment"}},{"kind":"Field","name":{"kind":"Name","value":"nameAudioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cardGame"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"dealId"}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"rule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"front"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"back"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"front"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"back"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"game"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WheelGame"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"howToPlay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","name":{"kind":"Name","value":"slicesPerWay"}},{"kind":"Field","name":{"kind":"Name","value":"innerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"soundUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outerRing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"itemCode"}},{"kind":"Field","name":{"kind":"Name","value":"wayCode"}},{"kind":"Field","name":{"kind":"Name","value":"title"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plain"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hint"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const CollectionHighlightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionHighlights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exerciseId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collected"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<CollectionHighlightsQuery, CollectionHighlightsQueryVariables>;
export const SetLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Locale"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setLanguage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}]}}]} as unknown as DocumentNode<SetLanguageMutation, SetLanguageMutationVariables>;
export const UserProfileDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserProfileDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"regionalProfileLayout"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"heightMm"}},{"kind":"Field","name":{"kind":"Name","value":"weightG"}},{"kind":"Field","name":{"kind":"Name","value":"fitnessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"practiceTime"}},{"kind":"Field","name":{"kind":"Name","value":"unitSystem"}},{"kind":"Field","name":{"kind":"Name","value":"kidProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"streak"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"week"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}},{"kind":"Field","name":{"kind":"Name","value":"inCurrentStreak"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserProfileDetailsQuery, UserProfileDetailsQueryVariables>;
export const CompleteReturnPracticeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteReturnPractice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"practiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeReturnPractice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"Argument","name":{"kind":"Name","value":"practiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"practiceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dayId"}},{"kind":"Field","name":{"kind":"Name","value":"streakPayload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStreak"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"dayNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"titleKey"}},{"kind":"Field","name":{"kind":"Name","value":"subtitleKey"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteReturnPracticeMutation, CompleteReturnPracticeMutationVariables>;
export const SetStartFlowDeclineFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetStartFlowDeclineFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flowType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFlowType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFlowDeclineReason"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"freeformText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setStartFlowDeclineFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"Argument","name":{"kind":"Name","value":"flowType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flowType"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}},{"kind":"Argument","name":{"kind":"Name","value":"freeformText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"freeformText"}}}]}]}}]} as unknown as DocumentNode<SetStartFlowDeclineFeedbackMutation, SetStartFlowDeclineFeedbackMutationVariables>;
export const SetStartFlowStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetStartFlowStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"flowType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFlowType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFlowStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setStartFlowStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"Argument","name":{"kind":"Name","value":"flowType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"flowType"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode<SetStartFlowStatusMutation, SetStartFlowStatusMutationVariables>;
export const ProfileFieldOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileFieldOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fitnessLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"practiceTime"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileFieldOptionsQuery, ProfileFieldOptionsQueryVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"heightMm"}},{"kind":"Field","name":{"kind":"Name","value":"weightG"}},{"kind":"Field","name":{"kind":"Name","value":"fitnessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"practiceTime"}},{"kind":"Field","name":{"kind":"Name","value":"unitSystem"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateKidProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateKidProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateKidProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateKidProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kidProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateKidProfileMutation, UpdateKidProfileMutationVariables>;
export const SubmitSurveyAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitSurveyAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitSurveyAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitSurveyAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SubmitSurveyAnswerMutation, SubmitSurveyAnswerMutationVariables>;
export const UserNoticeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserNotice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surface"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserNoticeSurface"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surface"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticeType"}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"}}]}}]}}]} as unknown as DocumentNode<UserNoticeQuery, UserNoticeQueryVariables>;
export const UserNoticeDeadEndDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserNoticeDeadEnd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userNotice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surface"},"value":{"kind":"EnumValue","value":"LAUNCH"}},{"kind":"Argument","name":{"kind":"Name","value":"peek"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticeType"}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"}}]}}]}}]} as unknown as DocumentNode<UserNoticeDeadEndQuery, UserNoticeDeadEndQueryVariables>;